(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref773"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref773"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j0yfM", function(module, exports) {
$parcel$extendImportMap({
    "d1pGu": "intlTelInput.2760692b.js",
    "74XyR": "intlTelInput.b1116f76.css",
    "3Cfgg": "flags.2dbfe2b1.webp",
    "dqjjv": "flags@2x.e41e4ba2.webp",
    "eh7Fp": "globe.96ea0b8a.webp",
    "5MEIo": "globe@2x.df85b384.webp",
    "f3S5A": "_intl-tel-input.a38737e6.css",
    "9gQnY": "testimonials.988d0e7b.js"
});

});

parcelRegister("gi2dh", function(module, exports) {
parcelRequire("bFVfU");
parcelRequire("a2UWR");
parcelRequire("fgjDA");
parcelRequire("7Zy92");

var $ihzXA = parcelRequire("ihzXA");

var $8fhAc = parcelRequire("8fhAc");

var $84Ks3 = parcelRequire("84Ks3");
window.copyToClipboard = (0, $8fhAc.copyToClipboard);
// Start Alpine when document is ready
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $ihzXA.default).start();
    // Self-guards: does nothing on pages without `.destination-navbar` (home, etc.)
    new (0, $84Ks3.DestinationNavbarSticky)();
});

});
parcelRegister("bFVfU", function(module, exports) {

var $ePYRN = parcelRequire("ePYRN");
// Ensure the global points to the actual htmx instance (ESM default export)
window.htmx = (0, $ePYRN.default);

});
parcelRegister("ePYRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acd50af40895408a$export$2e2bcd8739ae039; });
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.10'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        try {
            const url = new URL(path, window.location.href);
            path = url.pathname + url.search;
        } catch (e) {
        // fallback for malformed URLs
        }
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement,
                target: selector
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(CSS.escape(newNode.tagName) + '#' + CSS.escape(id));
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            removeClassFromElement(target, htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) addClassToElement(elt, htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) removeClassFromElement(elt, htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error + (detail.target ? ', ' + detail.target : ''));
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            addClassToElement(ic, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            if (!disabledElement.hasAttribute('disabled')) {
                disabledElement.setAttribute('disabled', '');
                disabledElement.setAttribute('data-disabled-by-htmx', '');
            }
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) removeClassFromElement(ic, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0 && disabledElement.hasAttribute('data-disabled-by-htmx')) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        let pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        let replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        if (pushUrl === 'false') pushUrl = null;
        if (replaceUrl === 'false') replaceUrl = null;
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push ?? 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            addClassToElement(target, htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $acd50af40895408a$export$2e2bcd8739ae039 = htmx;

});


parcelRegister("a2UWR", function(module, exports) {

var $9rGeX = parcelRequire("9rGeX");
document.addEventListener("DOMContentLoaded", function() {
    // Navbar
    let currentSubnav = null;
    const activeListeners = [];
    function addListener(element, type, handler, options) {
        if (!element) return;
        element.addEventListener(type, handler, options);
        activeListeners.push({
            element: element,
            type: type,
            handler: handler,
            options: options
        });
    }
    function addListenerAll(elements, type, handler, options) {
        elements.forEach(function(el) {
            addListener(el, type, handler, options);
        });
    }
    function removeAllListeners() {
        activeListeners.forEach(function(item) {
            item.element.removeEventListener(item.type, item.handler, item.options);
        });
        activeListeners.length = 0;
    }
    function removeClasses(selector, className) {
        document.querySelectorAll(selector).forEach(function(el) {
            el.classList.remove(className);
        });
    }
    function closeSubnavs() {
        removeClasses(".navbar-link", "active");
        removeClasses(".subnav", "showing");
    }
    function setupMobileNavbar() {
        // Mobile: show submenus on click
        const navbarLinks = Array.from(document.querySelectorAll(".navbar-link[show-subnav]"));
        addListenerAll(navbarLinks, "click", function(event) {
            const link = event.currentTarget;
            if (link.classList.contains("active")) {
                link.classList.remove("active");
                removeClasses(".subnav", "showing"); // hide all submenus
                return;
            }
            removeClasses(".navbar-link", "active");
            link.classList.add("active");
            removeClasses(".subnav", "showing"); // hide all submenus
            removeClasses(".subnav", "initial-cloak"); // Optimize page load (CTA)
            var subnavId = link.getAttribute("show-subnav");
            const subnav = document.getElementById(subnavId);
            if (subnav) subnav.classList.add("showing");
            currentSubnav = subnavId;
        });
        // Hide subnavs when clicking outside
        addListener(document, "click", function(event) {
            const target = event.target;
            if (target.closest('.subnav')) return;
            if (target.closest('.navbar-link')) return;
            removeClasses(".navbar-link", "active");
            removeClasses(".subnav", "showing");
        });
        // Back buttons inside subnav
        const backButtons = Array.from(document.querySelectorAll(".subnav .back"));
        addListenerAll(backButtons, "click", closeSubnavs);
        // Adjust padding for iOS toolbar
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            const toolbarHeight = 65;
            document.querySelectorAll(".navbar-menu, .subnav-container").forEach(function(el) {
                el.style.paddingBottom = toolbarHeight + "px";
            });
        }
    }
    function setupDesktopNavbar() {
        const links = Array.from(document.querySelectorAll(".navbar-link[show-subnav]"));
        addListenerAll(links, "mouseenter", function(event) {
            removeClasses(".subnav", "showing");
            var subnavId = event.currentTarget.getAttribute("show-subnav");
            const subnav = document.getElementById(subnavId);
            if (subnav) subnav.classList.add("showing");
            currentSubnav = subnavId;
        });
        addListenerAll(links, "mouseleave", function(event) {
            var subnavId = event.currentTarget.getAttribute("show-subnav");
            const subnav = document.getElementById(subnavId);
            if (subnav) subnav.classList.remove("showing");
        });
        const subnavs = Array.from(document.querySelectorAll(".subnav"));
        addListenerAll(subnavs, "mouseenter", function() {
            if (currentSubnav != null) {
                const subnav = document.getElementById(currentSubnav);
                if (subnav) subnav.classList.add("showing");
            }
        });
        addListenerAll(subnavs, "mouseleave", function(event) {
            currentSubnav = null;
            event.currentTarget.classList.remove("showing");
        });
    }
    function setupNavbar() {
        // Clear iOS toolbar padding on every setup so it doesn't persist across resize
        document.querySelectorAll(".navbar-menu, .subnav-container").forEach(function(el) {
            el.style.paddingBottom = "";
        });
        // Hide submenu if user scrolls down
        addListener(window, "scroll", function() {
            if (window.innerWidth > (0, $9rGeX.DESKTOP_BREAKPOINT) && window.scrollY > 40) {
                document.querySelectorAll(".navbar-menu .navbar-link.active").forEach(function(el) {
                    el.classList.remove("active");
                });
                document.querySelectorAll("section.subnav.showing").forEach(function(el) {
                    el.classList.remove("showing");
                });
            }
        });
        // const mobileMenu = window.innerWidth < DESKTOP_BREAKPOINT;  // calling window.innerWidth is expensive
        // if (mobileMenu) {
        //   setupMobileNavbar();
        // } else {
        //   // setupDesktopNavbar();
        //   setupMobileNavbar();  // For now, we'll try the same behavior on desktop
        // }
        setupMobileNavbar();
    }
    setupNavbar();
    // Throttled resize
    addListener(window, "resize", function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function() {
            removeAllListeners();
            setupNavbar();
        }, 250);
    });
    // One-time hover on navbar-wrapper to uncloak
    const navbarWrapper = document.querySelector(".navbar-wrapper");
    function handleNavbarWrapperEnter() {
        removeClasses(".subnav", "initial-cloak");
        if (navbarWrapper) navbarWrapper.removeEventListener("mouseenter", handleNavbarWrapperEnter);
    }
    if (navbarWrapper) addListener(navbarWrapper, "mouseenter", handleNavbarWrapperEnter);
// El toggle del burger menu ahora se maneja completamente con Alpine.js
// a través de @click="showMobileMenu = !showMobileMenu" y :class="{'is-active': showMobileMenu}"
// en el template navbar.html. No necesitamos JavaScript vanilla aquí.
});
// Scroll progress bar
(function() {
    const bar = document.getElementById("scroll-progress-bar");
    if (!bar) return;
    function updateProgress() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const pct = docHeight > 0 ? scrollTop / docHeight * 100 : 0;
        bar.style.width = pct + "%";
        bar.setAttribute("aria-valuenow", Math.round(pct));
    }
    window.addEventListener("scroll", updateProgress, {
        passive: true
    });
    updateProgress();
})();
const $474db07ae58897dd$var$userContinent = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/')[0].toLowerCase();
const $474db07ae58897dd$var$isStaff = JSON.parse(document.getElementById('is-staff-user').textContent);
const $474db07ae58897dd$var$destinationsListEurope = JSON.parse(document.getElementById('destinations-list-europe').textContent);
// Only show destinations from DESTINATIONS_LIST_EUROPE for europeans if not an admin
if ($474db07ae58897dd$var$userContinent === 'europe' && !$474db07ae58897dd$var$isStaff) {
    let subnavEurope = document.querySelector("#subnav-europa div.columns");
    const destinationElements = $474db07ae58897dd$var$destinationsListEurope.map((slug)=>document.querySelector(`#subnav-${slug}`));
    try {
        subnavEurope.querySelectorAll(".countries-column").forEach((el)=>el.remove());
    } catch (e) {
        console.error("Error removing countries-column elements:", e);
    }
    const nullElements = destinationElements.filter((el)=>el == null);
    if (nullElements.length > 0) console.error(`Error adding subnav elements, some destinations are null: ${$474db07ae58897dd$var$destinationsListEurope.join(', ')}`);
    const destinationsHTML = destinationElements.filter((el)=>el != null).map((el)=>el.outerHTML).join('');
    let columns = `
    <div class="column countries-column">
      <ul>
        ${destinationsHTML}
      </ul>
    </div>
    <div class="column countries-column"></div>
    <div class="column countries-column is-hidden-touch"></div>
  `;
    let htmlObject = document.createElement('div');
    htmlObject.innerHTML = columns;
    subnavEurope.querySelector(".otros").innerHTML = "";
    subnavEurope.querySelector(".otros").insertAdjacentHTML('beforebegin', columns);
    // Remove on desktop subnav
    subnavEurope.querySelector("ul.is-hidden-touch").remove();
    // Remove from the footer
    document.getElementById("footer-europa-anchor").remove();
}

});
parcelRegister("9rGeX", function(module, exports) {

$parcel$export(module.exports, "DESKTOP_BREAKPOINT", function () { return $64d3b995fd4a63e9$export$5fdfd40a67be54d; });
$parcel$export(module.exports, "DATEPICKER_MIN_YEAR", function () { return $64d3b995fd4a63e9$export$59f7cf13fd596f34; });
$parcel$export(module.exports, "DATEPICKER_MAX_YEAR", function () { return $64d3b995fd4a63e9$export$c8eb016025fe1a37; });
$parcel$export(module.exports, "PERMANENT_DNI_EXPIRATION_YEAR", function () { return $64d3b995fd4a63e9$export$5d77810988867a2d; });
$parcel$export(module.exports, "PERMANENT_DNI_EXPIRATION_MONTH", function () { return $64d3b995fd4a63e9$export$535cb184435a6164; });
$parcel$export(module.exports, "PERMANENT_DNI_EXPIRATION_DAY", function () { return $64d3b995fd4a63e9$export$1ea75e86fa30fe52; });
const $64d3b995fd4a63e9$export$5fdfd40a67be54d = 1075;
const $64d3b995fd4a63e9$export$483be101ede28c3f = 768;
const $64d3b995fd4a63e9$export$59f7cf13fd596f34 = 1900;
const $64d3b995fd4a63e9$export$c8eb016025fe1a37 = 2100;
const $64d3b995fd4a63e9$export$5d77810988867a2d = 9999;
const $64d3b995fd4a63e9$export$535cb184435a6164 = 1;
const $64d3b995fd4a63e9$export$1ea75e86fa30fe52 = 1;

});


parcelRegister("fgjDA", function(module, exports) {
// Change nav on scroll
const $d54ef46d2949276b$var$header = document.querySelector("nav.navbar-wrapper");
const $d54ef46d2949276b$var$addClassOnScroll = ()=>$d54ef46d2949276b$var$header.classList.add("sticky");
const $d54ef46d2949276b$var$removeClassOnScroll = ()=>$d54ef46d2949276b$var$header.classList.remove("sticky");
let $d54ef46d2949276b$var$navbarOpened = false;
window.addEventListener("scroll", function() {
    let scrollpos = window.scrollY;
    if (scrollpos > 60) $d54ef46d2949276b$var$addClassOnScroll();
    // We separate the two if statements to avoid flickering
    if (scrollpos < 30) $d54ef46d2949276b$var$removeClassOnScroll();
});

});

parcelRegister("7Zy92", function(module, exports) {

var $jWUp2 = parcelRequire("jWUp2");
const $651dc148d0106b0a$var$MODAL_ID = 'destination_unavailable_modal';
const $651dc148d0106b0a$var$FEEDBACK_MODAL_ID = 'destination_unavailable_feedback_modal';
document.addEventListener('DOMContentLoaded', ()=>{
    let isMarketable = null;
    let destinationSlug = null;
    let destinationSlugs = null;
    try {
        isMarketable = (0, $jWUp2.getJsonScriptData)('destination_is_marketable');
        destinationSlug = (0, $jWUp2.getJsonScriptData)('destination_slug');
        destinationSlugs = [
            destinationSlug
        ];
    } catch  {
    // In the lead generator we won't have these JSON script tags.
    // destinationSlugs will be set on calling the window.openUnmarketableDestinationModal function 'manually'.
    }
    let modalPromise = null;
    function openModal(modal) {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
    }
    // The modal markup isn't rendered into the page so crawlers don't index its
    // (hidden) content. It's fetched on demand the first time it's needed, then cached.
    function loadModal() {
        if (modalPromise) return modalPromise;
        let basePromise;
        const existingModal = document.getElementById($651dc148d0106b0a$var$MODAL_ID);
        if (existingModal) basePromise = Promise.resolve(existingModal);
        else if (destinationSlug) basePromise = fetch(`/ajax/unmarketable-destination-modal/${destinationSlug}/`).then((response)=>{
            if (!response.ok) throw new Error('Failed to load unmarketable destination modal');
            return response.text();
        }).then((html)=>{
            document.body.insertAdjacentHTML('beforeend', html);
            const modal = document.getElementById($651dc148d0106b0a$var$MODAL_ID);
            if (window.htmx && typeof window.htmx.process === 'function') window.htmx.process(modal);
            return modal;
        });
        else basePromise = Promise.reject(new Error('Unmarketable destination modal is not available'));
        modalPromise = basePromise.then((modal)=>{
            setupModal(modal);
            return modal;
        }).catch((error)=>{
            modalPromise = null;
            throw error;
        });
        return modalPromise;
    }
    const ctas = document.querySelectorAll('.js-lead-cta');
    if (ctas.length && isMarketable === false) {
        // The user is very likely to click a CTA on this page, so start fetching
        // the modal now instead of waiting for the click.
        loadModal().catch((error)=>console.error(error));
        ctas.forEach((cta)=>{
            cta.addEventListener('click', (event)=>{
                event.preventDefault();
                loadModal().then(openModal).catch((error)=>console.error(error));
            });
        });
    }
    window.openUnmarketableDestinationModal = (slugs)=>{
        destinationSlugs = slugs;
        loadModal().then(openModal).catch((error)=>console.error(error));
    };
    function setupModal(modal) {
        const feedbackModal = document.getElementById($651dc148d0106b0a$var$FEEDBACK_MODAL_ID);
        async function sendAvailabilityRequest(email, acceptedTerms, destination_slug) {
            const csrfInput = document.querySelector('[name=csrfmiddlewaretoken]');
            if (!csrfInput) throw new Error('CSRF token input not found');
            const csrfToken = csrfInput.value;
            const response = await fetch('/ajax/destination-availability-request/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify({
                    email: email,
                    accepted_terms: acceptedTerms,
                    destination_slug: destination_slug
                })
            });
            if (!response.ok) throw new Error('Request failed');
            return response.json();
        }
        const closeMainModal = ()=>{
            modal.classList.remove('is-active');
            modal.setAttribute('aria-hidden', 'true');
        };
        modal.querySelectorAll('[data-close-modal]').forEach((el)=>{
            el.addEventListener('click', ()=>{
                closeMainModal();
            });
        });
        const showFeedbackModal = ({ title: title, message: message, isError: isError })=>{
            if (!feedbackModal) return;
            const titleElement = document.getElementById('unmarketable_destination_feedback_title');
            const messageElement = document.getElementById('unmarketable_destination_feedback_message');
            if (titleElement) {
                titleElement.textContent = title;
                titleElement.classList.toggle('has-text-danger', isError);
                titleElement.classList.toggle('has-text-success', !isError);
            }
            if (messageElement) messageElement.textContent = message;
            feedbackModal.classList.add('is-active');
            feedbackModal.setAttribute('aria-hidden', 'false');
        };
        if (feedbackModal) feedbackModal.querySelectorAll('[data-close-feedback-modal]').forEach((el)=>{
            el.addEventListener('click', ()=>{
                feedbackModal.classList.remove('is-active');
                feedbackModal.setAttribute('aria-hidden', 'true');
            });
        });
        const emailInput = document.getElementById('unmarketable_destination_email');
        const termsCheckbox = document.getElementById('unmarketable_destination_terms');
        const submitButton = document.getElementById('unmarketable_destination_submit');
        const errorElement = document.getElementById('unmarketable_destination_error');
        let isSubmitting = false;
        if (submitButton && emailInput && termsCheckbox && errorElement) submitButton.addEventListener('click', async ()=>{
            if (isSubmitting) return;
            const email = emailInput.value.trim();
            if (!email) {
                errorElement.textContent = gettext('Please enter your email address');
                return;
            }
            if (!(0, $jWUp2.isValidEmailAddress)(email)) {
                errorElement.textContent = gettext('Please enter a valid email address');
                return;
            }
            if (!termsCheckbox.checked) {
                errorElement.textContent = gettext('You must accept the terms to continue');
                return;
            }
            errorElement.textContent = '';
            isSubmitting = true;
            submitButton.disabled = true;
            try {
                for (const destination_slug of destinationSlugs)await sendAvailabilityRequest(email, termsCheckbox.checked, destination_slug);
                closeMainModal();
                showFeedbackModal({
                    title: gettext('Request sent'),
                    message: gettext('We will notify you when this destination is available again.'),
                    isError: false
                });
            } catch (e) {
                errorElement.textContent = '';
                closeMainModal();
                showFeedbackModal({
                    title: gettext('Request failed'),
                    message: gettext('An error occurred while saving your email. Please try again.'),
                    isError: true
                });
                console.error(e);
            } finally{
                isSubmitting = false;
                submitButton.disabled = false;
            }
        });
    }
});

});
parcelRegister("jWUp2", function(module, exports) {

$parcel$export(module.exports, "setCookieOrSessionStorage", function () { return $7c56df80d809a685$export$a6cee254afd0e22b; });
$parcel$export(module.exports, "getCookieOrSessionStorage", function () { return $7c56df80d809a685$export$99823654a189bd51; });
$parcel$export(module.exports, "isValidEmailAddress", function () { return $7c56df80d809a685$export$866f45a7554d0870; });
$parcel$export(module.exports, "getJsonScriptData", function () { return $7c56df80d809a685$export$fc67981ad94d84a; });
$parcel$export(module.exports, "parseDate", function () { return $7c56df80d809a685$export$6b862160d295c8e; });

var $9rGeX = parcelRequire("9rGeX");
function $7c56df80d809a685$export$a6cee254afd0e22b(name, value, days, session = false) {
    if (session) {
        sessionStorage.setItem(name, value);
        return;
    }
    try {
        // Try to set the cookie
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
        // Check if the cookie was set successfully
        if (document.cookie.indexOf(name + "=") === -1) throw new Error("Cookies are not supported");
    } catch (e) {
        // Fallback to sessionStorage
        sessionStorage.setItem(name, value);
    }
}
function $7c56df80d809a685$export$99823654a189bd51(name) {
    // Try to get the cookie
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    // Fallback to sessionStorage
    return sessionStorage.getItem(name);
}
function $7c56df80d809a685$export$866f45a7554d0870(emailAddress) {
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
}
function $7c56df80d809a685$export$fc67981ad94d84a(key) {
    const element = document.getElementById(key);
    if (!element) throw new Error(`Element with id ${key} not found`);
    try {
        return JSON.parse(element.textContent);
    } catch (e) {
        throw new Error(`Invalid JSON content in element with id ${key}`);
    }
}
function $7c56df80d809a685$export$6b862160d295c8e(dateString) {
    if (!dateString || !dateString.trim()) return null;
    if (dateString.includes('-')) {
        const parts = dateString.split('-');
        if (parts.length !== 3) return null;
        if (parts[0].length === 4) return new Date(parts[0], parts[1] - 1, parts[2]);
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }
    const parts = dateString.split('/');
    if (parts.length !== 3) return null;
    if (parts[0].length === 4) return new Date(parts[0], parts[1] - 1, parts[2]);
    return new Date(parts[2], parts[1] - 1, parts[0]);
}
function $7c56df80d809a685$export$c9701fa3c59a2efb(dateString) {
    const parsedDate = $7c56df80d809a685$export$6b862160d295c8e(dateString);
    if (!parsedDate || Number.isNaN(parsedDate.getTime())) return false;
    return parsedDate.getFullYear() === (0, $9rGeX.PERMANENT_DNI_EXPIRATION_YEAR) && parsedDate.getMonth() === (0, $9rGeX.PERMANENT_DNI_EXPIRATION_MONTH) - 1 && parsedDate.getDate() === (0, $9rGeX.PERMANENT_DNI_EXPIRATION_DAY);
}
function $7c56df80d809a685$export$d07f57595c356899(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("ihzXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de7dfb6e6466d99d$export$2e2bcd8739ae039; });
/* v8 ignore start */ 
var $aGuA6 = parcelRequire("aGuA6");

var $e6Ki2 = parcelRequire("e6Ki2");

var $1zle1 = parcelRequire("1zle1");

var $1t392 = parcelRequire("1t392");
(0, $aGuA6.default).data('guideFormModal', (0, $e6Ki2.default));
(0, $aGuA6.default).data('alpineBodyData', (0, $1zle1.default));
(0, $aGuA6.default).data('cookiesModal', (0, $1t392.default));
window.Alpine = (0, $aGuA6.default);
var // Export Alpine instead of starting it immediately
$de7dfb6e6466d99d$export$2e2bcd8739ae039 /* v8 ignore end */  = (0, $aGuA6.default);

});
parcelRegister("aGuA6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c758c6c7663877f$export$2e2bcd8739ae039; });
// packages/alpinejs/src/scheduler.js
var $7c758c6c7663877f$var$flushPending = false;
var $7c758c6c7663877f$var$flushing = false;
var $7c758c6c7663877f$var$queue = [];
var $7c758c6c7663877f$var$lastFlushedIndex = -1;
var $7c758c6c7663877f$var$transactionActive = false;
function $7c758c6c7663877f$var$scheduler(callback) {
    $7c758c6c7663877f$var$queueJob(callback);
}
function $7c758c6c7663877f$var$startTransaction() {
    $7c758c6c7663877f$var$transactionActive = true;
}
function $7c758c6c7663877f$var$commitTransaction() {
    $7c758c6c7663877f$var$transactionActive = false;
    $7c758c6c7663877f$var$queueFlush();
}
function $7c758c6c7663877f$var$queueJob(job) {
    if (!$7c758c6c7663877f$var$queue.includes(job)) $7c758c6c7663877f$var$queue.push(job);
    $7c758c6c7663877f$var$queueFlush();
}
function $7c758c6c7663877f$var$dequeueJob(job) {
    let index = $7c758c6c7663877f$var$queue.indexOf(job);
    if (index !== -1 && index > $7c758c6c7663877f$var$lastFlushedIndex) $7c758c6c7663877f$var$queue.splice(index, 1);
}
function $7c758c6c7663877f$var$queueFlush() {
    if (!$7c758c6c7663877f$var$flushing && !$7c758c6c7663877f$var$flushPending) {
        if ($7c758c6c7663877f$var$transactionActive) return;
        $7c758c6c7663877f$var$flushPending = true;
        queueMicrotask($7c758c6c7663877f$var$flushJobs);
    }
}
function $7c758c6c7663877f$var$flushJobs() {
    $7c758c6c7663877f$var$flushPending = false;
    $7c758c6c7663877f$var$flushing = true;
    for(let i = 0; i < $7c758c6c7663877f$var$queue.length; i++){
        $7c758c6c7663877f$var$queue[i]();
        $7c758c6c7663877f$var$lastFlushedIndex = i;
    }
    $7c758c6c7663877f$var$queue.length = 0;
    $7c758c6c7663877f$var$lastFlushedIndex = -1;
    $7c758c6c7663877f$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $7c758c6c7663877f$var$reactive;
var $7c758c6c7663877f$var$effect;
var $7c758c6c7663877f$var$release;
var $7c758c6c7663877f$var$raw;
var $7c758c6c7663877f$var$shouldSchedule = true;
function $7c758c6c7663877f$var$disableEffectScheduling(callback) {
    $7c758c6c7663877f$var$shouldSchedule = false;
    callback();
    $7c758c6c7663877f$var$shouldSchedule = true;
}
function $7c758c6c7663877f$var$setReactivityEngine(engine) {
    $7c758c6c7663877f$var$reactive = engine.reactive;
    $7c758c6c7663877f$var$release = engine.release;
    $7c758c6c7663877f$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($7c758c6c7663877f$var$shouldSchedule) $7c758c6c7663877f$var$scheduler(task);
                else task();
            }
        });
    $7c758c6c7663877f$var$raw = engine.raw;
}
function $7c758c6c7663877f$var$overrideEffect(override) {
    $7c758c6c7663877f$var$effect = override;
}
function $7c758c6c7663877f$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $7c758c6c7663877f$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $7c758c6c7663877f$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $7c758c6c7663877f$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $7c758c6c7663877f$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>$7c758c6c7663877f$var$release(effectReference);
}
async function $7c758c6c7663877f$var$transaction(callback) {
    $7c758c6c7663877f$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $7c758c6c7663877f$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $7c758c6c7663877f$var$onAttributeAddeds = [];
var $7c758c6c7663877f$var$onElRemoveds = [];
var $7c758c6c7663877f$var$onElAddeds = [];
function $7c758c6c7663877f$var$onElAdded(callback) {
    $7c758c6c7663877f$var$onElAddeds.push(callback);
}
function $7c758c6c7663877f$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $7c758c6c7663877f$var$onElRemoveds.push(callback);
    }
}
function $7c758c6c7663877f$var$onAttributesAdded(callback) {
    $7c758c6c7663877f$var$onAttributeAddeds.push(callback);
}
function $7c758c6c7663877f$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $7c758c6c7663877f$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $7c758c6c7663877f$var$cleanupElement(el) {
    el._x_effects?.forEach($7c758c6c7663877f$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $7c758c6c7663877f$var$observer = new MutationObserver($7c758c6c7663877f$var$onMutate);
var $7c758c6c7663877f$var$currentlyObserving = false;
function $7c758c6c7663877f$var$startObservingMutations() {
    $7c758c6c7663877f$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $7c758c6c7663877f$var$currentlyObserving = true;
}
function $7c758c6c7663877f$var$stopObservingMutations() {
    $7c758c6c7663877f$var$flushObserver();
    $7c758c6c7663877f$var$observer.disconnect();
    $7c758c6c7663877f$var$currentlyObserving = false;
}
var $7c758c6c7663877f$var$queuedMutations = [];
function $7c758c6c7663877f$var$flushObserver() {
    let records = $7c758c6c7663877f$var$observer.takeRecords();
    $7c758c6c7663877f$var$queuedMutations.push(()=>records.length > 0 && $7c758c6c7663877f$var$onMutate(records));
    let queueLengthWhenTriggered = $7c758c6c7663877f$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($7c758c6c7663877f$var$queuedMutations.length === queueLengthWhenTriggered) while($7c758c6c7663877f$var$queuedMutations.length > 0)$7c758c6c7663877f$var$queuedMutations.shift()();
    });
}
function $7c758c6c7663877f$var$mutateDom(callback) {
    if (!$7c758c6c7663877f$var$currentlyObserving) return callback();
    $7c758c6c7663877f$var$stopObservingMutations();
    let result = callback();
    $7c758c6c7663877f$var$startObservingMutations();
    return result;
}
var $7c758c6c7663877f$var$isCollecting = false;
var $7c758c6c7663877f$var$deferredMutations = [];
function $7c758c6c7663877f$var$deferMutations() {
    $7c758c6c7663877f$var$isCollecting = true;
}
function $7c758c6c7663877f$var$flushAndStopDeferringMutations() {
    $7c758c6c7663877f$var$isCollecting = false;
    $7c758c6c7663877f$var$onMutate($7c758c6c7663877f$var$deferredMutations);
    $7c758c6c7663877f$var$deferredMutations = [];
}
function $7c758c6c7663877f$var$onMutate(mutations) {
    if ($7c758c6c7663877f$var$isCollecting) {
        $7c758c6c7663877f$var$deferredMutations = $7c758c6c7663877f$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $7c758c6c7663877f$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $7c758c6c7663877f$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $7c758c6c7663877f$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $7c758c6c7663877f$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $7c758c6c7663877f$var$scope(node) {
    return $7c758c6c7663877f$var$mergeProxies($7c758c6c7663877f$var$closestDataStack(node));
}
function $7c758c6c7663877f$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$7c758c6c7663877f$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $7c758c6c7663877f$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $7c758c6c7663877f$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $7c758c6c7663877f$var$closestDataStack(node.parentNode);
}
function $7c758c6c7663877f$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $7c758c6c7663877f$var$mergeProxyTrap);
}
function $7c758c6c7663877f$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $7c758c6c7663877f$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $7c758c6c7663877f$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $7c758c6c7663877f$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $7c758c6c7663877f$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $7c758c6c7663877f$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $7c758c6c7663877f$var$initInterceptors(data2) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $7c758c6c7663877f$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$7c758c6c7663877f$var$get(data2, path), (value)=>$7c758c6c7663877f$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $7c758c6c7663877f$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $7c758c6c7663877f$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $7c758c6c7663877f$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $7c758c6c7663877f$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $7c758c6c7663877f$var$magics = {};
function $7c758c6c7663877f$var$magic(name, callback) {
    $7c758c6c7663877f$var$magics[name] = callback;
}
function $7c758c6c7663877f$var$injectMagics(obj, el) {
    let memoizedUtilities = $7c758c6c7663877f$var$getUtilities(el);
    Object.entries($7c758c6c7663877f$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $7c758c6c7663877f$var$getUtilities(el) {
    let [utilities, cleanup2] = $7c758c6c7663877f$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $7c758c6c7663877f$var$interceptor,
        ...utilities
    };
    $7c758c6c7663877f$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $7c758c6c7663877f$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $7c758c6c7663877f$var$handleError(e, el, expression);
    }
}
function $7c758c6c7663877f$var$handleError(...args) {
    return $7c758c6c7663877f$var$errorHandler(...args);
}
var $7c758c6c7663877f$var$errorHandler = $7c758c6c7663877f$var$normalErrorHandler;
function $7c758c6c7663877f$var$setErrorHandler(handler4) {
    $7c758c6c7663877f$var$errorHandler = handler4;
}
function $7c758c6c7663877f$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $7c758c6c7663877f$var$shouldAutoEvaluateFunctions = true;
function $7c758c6c7663877f$var$dontAutoEvaluateFunctions(callback) {
    let cache = $7c758c6c7663877f$var$shouldAutoEvaluateFunctions;
    $7c758c6c7663877f$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $7c758c6c7663877f$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $7c758c6c7663877f$var$evaluate(el, expression, extras = {}) {
    let result;
    $7c758c6c7663877f$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $7c758c6c7663877f$var$evaluateLater(...args) {
    return $7c758c6c7663877f$var$theEvaluatorFunction(...args);
}
var $7c758c6c7663877f$var$theEvaluatorFunction = ()=>{};
function $7c758c6c7663877f$var$setEvaluator(newEvaluator) {
    $7c758c6c7663877f$var$theEvaluatorFunction = newEvaluator;
}
var $7c758c6c7663877f$var$theRawEvaluatorFunction;
function $7c758c6c7663877f$var$setRawEvaluator(newEvaluator) {
    $7c758c6c7663877f$var$theRawEvaluatorFunction = newEvaluator;
}
function $7c758c6c7663877f$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $7c758c6c7663877f$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$7c758c6c7663877f$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $7c758c6c7663877f$var$generateEvaluatorFromFunction(dataStack, expression) : $7c758c6c7663877f$var$generateEvaluatorFromString(dataStack, expression, el);
    return $7c758c6c7663877f$var$tryCatch.bind(null, el, expression, evaluator);
}
function $7c758c6c7663877f$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$7c758c6c7663877f$var$shouldAutoEvaluateFunctions) {
            $7c758c6c7663877f$var$runIfTypeOfFunction(receiver, func, $7c758c6c7663877f$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($7c758c6c7663877f$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $7c758c6c7663877f$var$runIfTypeOfFunction(receiver, result);
    };
}
var $7c758c6c7663877f$var$evaluatorMemo = {};
function $7c758c6c7663877f$var$generateFunctionFromString(expression, el) {
    if ($7c758c6c7663877f$var$evaluatorMemo[expression]) return $7c758c6c7663877f$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $7c758c6c7663877f$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $7c758c6c7663877f$var$evaluatorMemo[expression] = func;
    return func;
}
function $7c758c6c7663877f$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $7c758c6c7663877f$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $7c758c6c7663877f$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$7c758c6c7663877f$var$handleError(error2, el, expression));
            if (func.finished) {
                $7c758c6c7663877f$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $7c758c6c7663877f$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$7c758c6c7663877f$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $7c758c6c7663877f$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($7c758c6c7663877f$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$7c758c6c7663877f$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$7c758c6c7663877f$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $7c758c6c7663877f$var$evaluateRaw(...args) {
    return $7c758c6c7663877f$var$theRawEvaluatorFunction(...args);
}
function $7c758c6c7663877f$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $7c758c6c7663877f$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$7c758c6c7663877f$var$closestDataStack(el)
    ];
    let scope2 = $7c758c6c7663877f$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $7c758c6c7663877f$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $7c758c6c7663877f$var$prefixAsString = "x-";
function $7c758c6c7663877f$var$prefix(subject = "") {
    return $7c758c6c7663877f$var$prefixAsString + subject;
}
function $7c758c6c7663877f$var$setPrefix(newPrefix) {
    $7c758c6c7663877f$var$prefixAsString = newPrefix;
}
var $7c758c6c7663877f$var$directiveHandlers = {};
function $7c758c6c7663877f$var$directive(name, callback) {
    $7c758c6c7663877f$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$7c758c6c7663877f$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $7c758c6c7663877f$var$directiveOrder.indexOf(directive2);
            $7c758c6c7663877f$var$directiveOrder.splice(pos >= 0 ? pos : $7c758c6c7663877f$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $7c758c6c7663877f$var$directiveExists(name) {
    return Object.keys($7c758c6c7663877f$var$directiveHandlers).includes(name);
}
function $7c758c6c7663877f$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $7c758c6c7663877f$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($7c758c6c7663877f$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($7c758c6c7663877f$var$outNonAlpineAttributes).map($7c758c6c7663877f$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($7c758c6c7663877f$var$byPriority);
    return directives2.map((directive2)=>{
        return $7c758c6c7663877f$var$getDirectiveHandler(el, directive2);
    });
}
function $7c758c6c7663877f$var$attributesOnly(attributes) {
    return Array.from(attributes).map($7c758c6c7663877f$var$toTransformedAttributes()).filter((attr)=>!$7c758c6c7663877f$var$outNonAlpineAttributes(attr));
}
var $7c758c6c7663877f$var$isDeferringHandlers = false;
var $7c758c6c7663877f$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $7c758c6c7663877f$var$currentHandlerStackKey = Symbol();
function $7c758c6c7663877f$var$deferHandlingDirectives(callback) {
    $7c758c6c7663877f$var$isDeferringHandlers = true;
    let key = Symbol();
    $7c758c6c7663877f$var$currentHandlerStackKey = key;
    $7c758c6c7663877f$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($7c758c6c7663877f$var$directiveHandlerStacks.get(key).length)$7c758c6c7663877f$var$directiveHandlerStacks.get(key).shift()();
        $7c758c6c7663877f$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $7c758c6c7663877f$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $7c758c6c7663877f$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $7c758c6c7663877f$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $7c758c6c7663877f$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $7c758c6c7663877f$var$evaluateLater.bind($7c758c6c7663877f$var$evaluateLater, el),
        evaluate: $7c758c6c7663877f$var$evaluate.bind($7c758c6c7663877f$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $7c758c6c7663877f$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $7c758c6c7663877f$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $7c758c6c7663877f$var$getElementBoundUtilities(el);
    $7c758c6c7663877f$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $7c758c6c7663877f$var$isDeferringHandlers ? $7c758c6c7663877f$var$directiveHandlerStacks.get($7c758c6c7663877f$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $7c758c6c7663877f$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $7c758c6c7663877f$var$into = (i)=>i;
function $7c758c6c7663877f$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $7c758c6c7663877f$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $7c758c6c7663877f$var$attributeTransformers = [];
function $7c758c6c7663877f$var$mapAttributes(callback) {
    $7c758c6c7663877f$var$attributeTransformers.push(callback);
}
function $7c758c6c7663877f$var$outNonAlpineAttributes({ name: name }) {
    return $7c758c6c7663877f$var$alpineAttributeRegex().test(name);
}
var $7c758c6c7663877f$var$alpineAttributeRegex = ()=>new RegExp(`^${$7c758c6c7663877f$var$prefixAsString}([^:^.]+)\\b`);
function $7c758c6c7663877f$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($7c758c6c7663877f$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $7c758c6c7663877f$var$DEFAULT = "DEFAULT";
var $7c758c6c7663877f$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $7c758c6c7663877f$var$DEFAULT,
    "teleport"
];
function $7c758c6c7663877f$var$byPriority(a, b) {
    let typeA = $7c758c6c7663877f$var$directiveOrder.indexOf(a.type) === -1 ? $7c758c6c7663877f$var$DEFAULT : a.type;
    let typeB = $7c758c6c7663877f$var$directiveOrder.indexOf(b.type) === -1 ? $7c758c6c7663877f$var$DEFAULT : b.type;
    return $7c758c6c7663877f$var$directiveOrder.indexOf(typeA) - $7c758c6c7663877f$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $7c758c6c7663877f$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/walk.js
function $7c758c6c7663877f$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$7c758c6c7663877f$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $7c758c6c7663877f$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $7c758c6c7663877f$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $7c758c6c7663877f$var$started = false;
function $7c758c6c7663877f$var$start() {
    if ($7c758c6c7663877f$var$started) $7c758c6c7663877f$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $7c758c6c7663877f$var$started = true;
    if (!document.body) $7c758c6c7663877f$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $7c758c6c7663877f$var$dispatch(document, "alpine:init");
    $7c758c6c7663877f$var$dispatch(document, "alpine:initializing");
    $7c758c6c7663877f$var$startObservingMutations();
    $7c758c6c7663877f$var$onElAdded((el)=>$7c758c6c7663877f$var$initTree(el, $7c758c6c7663877f$var$walk));
    $7c758c6c7663877f$var$onElRemoved((el)=>$7c758c6c7663877f$var$destroyTree(el));
    $7c758c6c7663877f$var$onAttributesAdded((el, attrs)=>{
        $7c758c6c7663877f$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$7c758c6c7663877f$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($7c758c6c7663877f$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $7c758c6c7663877f$var$initTree(el);
    });
    $7c758c6c7663877f$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $7c758c6c7663877f$var$warnAboutMissingPlugins();
    });
}
var $7c758c6c7663877f$var$rootSelectorCallbacks = [];
var $7c758c6c7663877f$var$initSelectorCallbacks = [];
function $7c758c6c7663877f$var$rootSelectors() {
    return $7c758c6c7663877f$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $7c758c6c7663877f$var$allSelectors() {
    return $7c758c6c7663877f$var$rootSelectorCallbacks.concat($7c758c6c7663877f$var$initSelectorCallbacks).map((fn)=>fn());
}
function $7c758c6c7663877f$var$addRootSelector(selectorCallback) {
    $7c758c6c7663877f$var$rootSelectorCallbacks.push(selectorCallback);
}
function $7c758c6c7663877f$var$addInitSelector(selectorCallback) {
    $7c758c6c7663877f$var$initSelectorCallbacks.push(selectorCallback);
}
function $7c758c6c7663877f$var$closestRoot(el, includeInitSelectors = false) {
    return $7c758c6c7663877f$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $7c758c6c7663877f$var$allSelectors() : $7c758c6c7663877f$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $7c758c6c7663877f$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $7c758c6c7663877f$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $7c758c6c7663877f$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $7c758c6c7663877f$var$findClosest(el.parentElement, callback);
}
function $7c758c6c7663877f$var$isRoot(el) {
    return $7c758c6c7663877f$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $7c758c6c7663877f$var$initInterceptors2 = [];
function $7c758c6c7663877f$var$interceptInit(callback) {
    $7c758c6c7663877f$var$initInterceptors2.push(callback);
}
var $7c758c6c7663877f$var$markerDispenser = 1;
function $7c758c6c7663877f$var$initTree(el, walker = $7c758c6c7663877f$var$walk, intercept = ()=>{}) {
    if ($7c758c6c7663877f$var$findClosest(el, (i)=>i._x_ignore)) return;
    $7c758c6c7663877f$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $7c758c6c7663877f$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $7c758c6c7663877f$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $7c758c6c7663877f$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $7c758c6c7663877f$var$destroyTree(root, walker = $7c758c6c7663877f$var$walk) {
    walker(root, (el)=>{
        $7c758c6c7663877f$var$cleanupElement(el);
        $7c758c6c7663877f$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $7c758c6c7663877f$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($7c758c6c7663877f$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $7c758c6c7663877f$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $7c758c6c7663877f$var$tickStack = [];
var $7c758c6c7663877f$var$isHolding = false;
function $7c758c6c7663877f$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $7c758c6c7663877f$var$isHolding || setTimeout(()=>{
            $7c758c6c7663877f$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $7c758c6c7663877f$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $7c758c6c7663877f$var$releaseNextTicks() {
    $7c758c6c7663877f$var$isHolding = false;
    while($7c758c6c7663877f$var$tickStack.length)$7c758c6c7663877f$var$tickStack.shift()();
}
function $7c758c6c7663877f$var$holdNextTicks() {
    $7c758c6c7663877f$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $7c758c6c7663877f$var$setClasses(el, value) {
    if (Array.isArray(value)) return $7c758c6c7663877f$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $7c758c6c7663877f$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $7c758c6c7663877f$var$setClasses(el, value());
    return $7c758c6c7663877f$var$setClassesFromString(el, value);
}
function $7c758c6c7663877f$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $7c758c6c7663877f$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$7c758c6c7663877f$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $7c758c6c7663877f$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $7c758c6c7663877f$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $7c758c6c7663877f$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $7c758c6c7663877f$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $7c758c6c7663877f$var$setStylesFromObject(el, value);
    return $7c758c6c7663877f$var$setStylesFromString(el, value);
}
function $7c758c6c7663877f$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $7c758c6c7663877f$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $7c758c6c7663877f$var$setStyles(el, previousStyles);
    };
}
function $7c758c6c7663877f$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $7c758c6c7663877f$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $7c758c6c7663877f$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$7c758c6c7663877f$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $7c758c6c7663877f$var$registerTransitionsFromHelper(el, modifiers, value);
    else $7c758c6c7663877f$var$registerTransitionsFromClassString(el, expression, value);
});
function $7c758c6c7663877f$var$registerTransitionsFromClassString(el, classString, stage) {
    $7c758c6c7663877f$var$registerTransitionObject(el, $7c758c6c7663877f$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $7c758c6c7663877f$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $7c758c6c7663877f$var$registerTransitionObject(el, $7c758c6c7663877f$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $7c758c6c7663877f$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $7c758c6c7663877f$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $7c758c6c7663877f$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $7c758c6c7663877f$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $7c758c6c7663877f$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $7c758c6c7663877f$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $7c758c6c7663877f$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $7c758c6c7663877f$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $7c758c6c7663877f$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $7c758c6c7663877f$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $7c758c6c7663877f$var$closestHide(parent);
}
function $7c758c6c7663877f$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $7c758c6c7663877f$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $7c758c6c7663877f$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $7c758c6c7663877f$var$once(()=>{
        $7c758c6c7663877f$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $7c758c6c7663877f$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $7c758c6c7663877f$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $7c758c6c7663877f$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $7c758c6c7663877f$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $7c758c6c7663877f$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $7c758c6c7663877f$var$mutateDom(()=>{
                stages.end();
            });
            $7c758c6c7663877f$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $7c758c6c7663877f$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $7c758c6c7663877f$var$isCloning = false;
function $7c758c6c7663877f$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$7c758c6c7663877f$var$isCloning ? fallback(...args) : callback(...args);
}
function $7c758c6c7663877f$var$onlyDuringClone(callback) {
    return (...args)=>$7c758c6c7663877f$var$isCloning && callback(...args);
}
var $7c758c6c7663877f$var$interceptors = [];
function $7c758c6c7663877f$var$interceptClone(callback) {
    $7c758c6c7663877f$var$interceptors.push(callback);
}
function $7c758c6c7663877f$var$cloneNode(from, to) {
    $7c758c6c7663877f$var$interceptors.forEach((i)=>i(from, to));
    $7c758c6c7663877f$var$isCloning = true;
    $7c758c6c7663877f$var$dontRegisterReactiveSideEffects(()=>{
        $7c758c6c7663877f$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $7c758c6c7663877f$var$isCloning = false;
}
var $7c758c6c7663877f$var$isCloningLegacy = false;
function $7c758c6c7663877f$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $7c758c6c7663877f$var$isCloning = true;
    $7c758c6c7663877f$var$isCloningLegacy = true;
    $7c758c6c7663877f$var$dontRegisterReactiveSideEffects(()=>{
        $7c758c6c7663877f$var$cloneTree(newEl);
    });
    $7c758c6c7663877f$var$isCloning = false;
    $7c758c6c7663877f$var$isCloningLegacy = false;
}
function $7c758c6c7663877f$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $7c758c6c7663877f$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $7c758c6c7663877f$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $7c758c6c7663877f$var$initTree(el, shallowWalker);
}
function $7c758c6c7663877f$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $7c758c6c7663877f$var$effect;
    $7c758c6c7663877f$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $7c758c6c7663877f$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $7c758c6c7663877f$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $7c758c6c7663877f$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $7c758c6c7663877f$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $7c758c6c7663877f$var$camelCase(name) : name;
    switch(name){
        case "value":
            $7c758c6c7663877f$var$bindInputValue(el, value);
            break;
        case "style":
            $7c758c6c7663877f$var$bindStyles(el, value);
            break;
        case "class":
            $7c758c6c7663877f$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $7c758c6c7663877f$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $7c758c6c7663877f$var$bindAttribute(el, name, value);
            break;
    }
}
function $7c758c6c7663877f$var$bindInputValue(el, value) {
    if ($7c758c6c7663877f$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($7c758c6c7663877f$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$7c758c6c7663877f$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $7c758c6c7663877f$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $7c758c6c7663877f$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $7c758c6c7663877f$var$setClasses(el, value);
}
function $7c758c6c7663877f$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $7c758c6c7663877f$var$setStyles(el, value);
}
function $7c758c6c7663877f$var$bindAttributeAndProperty(el, name, value) {
    $7c758c6c7663877f$var$bindAttribute(el, name, value);
    $7c758c6c7663877f$var$setPropertyIfChanged(el, name, value);
}
function $7c758c6c7663877f$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $7c758c6c7663877f$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($7c758c6c7663877f$var$isBooleanAttr(name)) value = name;
        $7c758c6c7663877f$var$setIfChanged(el, name, value);
    }
}
function $7c758c6c7663877f$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $7c758c6c7663877f$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $7c758c6c7663877f$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $7c758c6c7663877f$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $7c758c6c7663877f$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $7c758c6c7663877f$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $7c758c6c7663877f$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $7c758c6c7663877f$var$isBooleanAttr(attrName) {
    return $7c758c6c7663877f$var$booleanAttributes.has(attrName);
}
function $7c758c6c7663877f$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $7c758c6c7663877f$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $7c758c6c7663877f$var$getAttributeBinding(el, name, fallback);
}
function $7c758c6c7663877f$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $7c758c6c7663877f$var$dontAutoEvaluateFunctions(()=>{
            return $7c758c6c7663877f$var$evaluate(el, binding.expression);
        });
    }
    return $7c758c6c7663877f$var$getAttributeBinding(el, name, fallback);
}
function $7c758c6c7663877f$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($7c758c6c7663877f$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $7c758c6c7663877f$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $7c758c6c7663877f$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $7c758c6c7663877f$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $7c758c6c7663877f$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $7c758c6c7663877f$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $7c758c6c7663877f$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($7c758c6c7663877f$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($7c758c6c7663877f$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($7c758c6c7663877f$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $7c758c6c7663877f$var$release(reference);
    };
}
function $7c758c6c7663877f$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $7c758c6c7663877f$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($7c758c6c7663877f$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $7c758c6c7663877f$var$stores = {};
var $7c758c6c7663877f$var$isReactive = false;
function $7c758c6c7663877f$var$store(name, value) {
    if (!$7c758c6c7663877f$var$isReactive) {
        $7c758c6c7663877f$var$stores = $7c758c6c7663877f$var$reactive($7c758c6c7663877f$var$stores);
        $7c758c6c7663877f$var$isReactive = true;
    }
    if (value === void 0) return $7c758c6c7663877f$var$stores[name];
    $7c758c6c7663877f$var$stores[name] = value;
    $7c758c6c7663877f$var$initInterceptors($7c758c6c7663877f$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $7c758c6c7663877f$var$stores[name].init();
}
function $7c758c6c7663877f$var$getStores() {
    return $7c758c6c7663877f$var$stores;
}
// packages/alpinejs/src/binds.js
var $7c758c6c7663877f$var$binds = {};
function $7c758c6c7663877f$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $7c758c6c7663877f$var$applyBindingsObject(name, getBindings());
    else $7c758c6c7663877f$var$binds[name] = getBindings;
    return ()=>{};
}
function $7c758c6c7663877f$var$injectBindingProviders(obj) {
    Object.entries($7c758c6c7663877f$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $7c758c6c7663877f$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $7c758c6c7663877f$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $7c758c6c7663877f$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $7c758c6c7663877f$var$datas = {};
function $7c758c6c7663877f$var$data(name, callback) {
    $7c758c6c7663877f$var$datas[name] = callback;
}
function $7c758c6c7663877f$var$injectDataProviders(obj, context) {
    Object.entries($7c758c6c7663877f$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $7c758c6c7663877f$var$Alpine = {
    get reactive () {
        return $7c758c6c7663877f$var$reactive;
    },
    get release () {
        return $7c758c6c7663877f$var$release;
    },
    get effect () {
        return $7c758c6c7663877f$var$effect;
    },
    get raw () {
        return $7c758c6c7663877f$var$raw;
    },
    get transaction () {
        return $7c758c6c7663877f$var$transaction;
    },
    version: "3.15.12",
    flushAndStopDeferringMutations: $7c758c6c7663877f$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $7c758c6c7663877f$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $7c758c6c7663877f$var$disableEffectScheduling,
    startObservingMutations: $7c758c6c7663877f$var$startObservingMutations,
    stopObservingMutations: $7c758c6c7663877f$var$stopObservingMutations,
    setReactivityEngine: $7c758c6c7663877f$var$setReactivityEngine,
    onAttributeRemoved: $7c758c6c7663877f$var$onAttributeRemoved,
    onAttributesAdded: $7c758c6c7663877f$var$onAttributesAdded,
    closestDataStack: $7c758c6c7663877f$var$closestDataStack,
    skipDuringClone: $7c758c6c7663877f$var$skipDuringClone,
    onlyDuringClone: $7c758c6c7663877f$var$onlyDuringClone,
    addRootSelector: $7c758c6c7663877f$var$addRootSelector,
    addInitSelector: $7c758c6c7663877f$var$addInitSelector,
    setErrorHandler: $7c758c6c7663877f$var$setErrorHandler,
    interceptClone: $7c758c6c7663877f$var$interceptClone,
    addScopeToNode: $7c758c6c7663877f$var$addScopeToNode,
    deferMutations: $7c758c6c7663877f$var$deferMutations,
    mapAttributes: $7c758c6c7663877f$var$mapAttributes,
    evaluateLater: $7c758c6c7663877f$var$evaluateLater,
    interceptInit: $7c758c6c7663877f$var$interceptInit,
    initInterceptors: $7c758c6c7663877f$var$initInterceptors,
    injectMagics: $7c758c6c7663877f$var$injectMagics,
    setEvaluator: $7c758c6c7663877f$var$setEvaluator,
    setRawEvaluator: $7c758c6c7663877f$var$setRawEvaluator,
    mergeProxies: $7c758c6c7663877f$var$mergeProxies,
    extractProp: $7c758c6c7663877f$var$extractProp,
    findClosest: $7c758c6c7663877f$var$findClosest,
    onElRemoved: $7c758c6c7663877f$var$onElRemoved,
    closestRoot: $7c758c6c7663877f$var$closestRoot,
    destroyTree: $7c758c6c7663877f$var$destroyTree,
    interceptor: $7c758c6c7663877f$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $7c758c6c7663877f$var$transition,
    setStyles: // INTERNAL
    $7c758c6c7663877f$var$setStyles,
    mutateDom: // INTERNAL
    $7c758c6c7663877f$var$mutateDom,
    directive: $7c758c6c7663877f$var$directive,
    entangle: $7c758c6c7663877f$var$entangle,
    throttle: $7c758c6c7663877f$var$throttle,
    debounce: $7c758c6c7663877f$var$debounce,
    evaluate: $7c758c6c7663877f$var$evaluate,
    evaluateRaw: $7c758c6c7663877f$var$evaluateRaw,
    initTree: $7c758c6c7663877f$var$initTree,
    nextTick: $7c758c6c7663877f$var$nextTick,
    prefixed: $7c758c6c7663877f$var$prefix,
    prefix: $7c758c6c7663877f$var$setPrefix,
    plugin: $7c758c6c7663877f$var$plugin,
    magic: $7c758c6c7663877f$var$magic,
    store: $7c758c6c7663877f$var$store,
    start: $7c758c6c7663877f$var$start,
    clone: $7c758c6c7663877f$var$clone,
    cloneNode: // INTERNAL
    $7c758c6c7663877f$var$cloneNode,
    // INTERNAL
    bound: $7c758c6c7663877f$var$getBinding,
    $data: $7c758c6c7663877f$var$scope,
    watch: $7c758c6c7663877f$var$watch,
    walk: $7c758c6c7663877f$var$walk,
    data: $7c758c6c7663877f$var$data,
    bind: $7c758c6c7663877f$var$bind2
};
var $7c758c6c7663877f$var$alpine_default = $7c758c6c7663877f$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $7c758c6c7663877f$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $7c758c6c7663877f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $7c758c6c7663877f$var$isBooleanAttr2 = /* @__PURE__ */ $7c758c6c7663877f$var$makeMap($7c758c6c7663877f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $7c758c6c7663877f$var$EMPTY_OBJ = Object.freeze({});
var $7c758c6c7663877f$var$EMPTY_ARR = Object.freeze([]);
var $7c758c6c7663877f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $7c758c6c7663877f$var$hasOwn = (val, key)=>$7c758c6c7663877f$var$hasOwnProperty.call(val, key);
var $7c758c6c7663877f$var$isArray = Array.isArray;
var $7c758c6c7663877f$var$isMap = (val)=>$7c758c6c7663877f$var$toTypeString(val) === "[object Map]";
var $7c758c6c7663877f$var$isString = (val)=>typeof val === "string";
var $7c758c6c7663877f$var$isSymbol = (val)=>typeof val === "symbol";
var $7c758c6c7663877f$var$isObject = (val)=>val !== null && typeof val === "object";
var $7c758c6c7663877f$var$objectToString = Object.prototype.toString;
var $7c758c6c7663877f$var$toTypeString = (value)=>$7c758c6c7663877f$var$objectToString.call(value);
var $7c758c6c7663877f$var$toRawType = (value)=>{
    return $7c758c6c7663877f$var$toTypeString(value).slice(8, -1);
};
var $7c758c6c7663877f$var$isIntegerKey = (key)=>$7c758c6c7663877f$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $7c758c6c7663877f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $7c758c6c7663877f$var$camelizeRE = /-(\w)/g;
var $7c758c6c7663877f$var$camelize = $7c758c6c7663877f$var$cacheStringFunction((str)=>{
    return str.replace($7c758c6c7663877f$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $7c758c6c7663877f$var$hyphenateRE = /\B([A-Z])/g;
var $7c758c6c7663877f$var$hyphenate = $7c758c6c7663877f$var$cacheStringFunction((str)=>str.replace($7c758c6c7663877f$var$hyphenateRE, "-$1").toLowerCase());
var $7c758c6c7663877f$var$capitalize = $7c758c6c7663877f$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $7c758c6c7663877f$var$toHandlerKey = $7c758c6c7663877f$var$cacheStringFunction((str)=>str ? `on${$7c758c6c7663877f$var$capitalize(str)}` : ``);
var $7c758c6c7663877f$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $7c758c6c7663877f$var$targetMap = /* @__PURE__ */ new WeakMap();
var $7c758c6c7663877f$var$effectStack = [];
var $7c758c6c7663877f$var$activeEffect;
var $7c758c6c7663877f$var$ITERATE_KEY = Symbol("iterate");
var $7c758c6c7663877f$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $7c758c6c7663877f$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $7c758c6c7663877f$var$effect2(fn, options = $7c758c6c7663877f$var$EMPTY_OBJ) {
    if ($7c758c6c7663877f$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $7c758c6c7663877f$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $7c758c6c7663877f$var$stop(effect3) {
    if (effect3.active) {
        $7c758c6c7663877f$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $7c758c6c7663877f$var$uid = 0;
function $7c758c6c7663877f$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$7c758c6c7663877f$var$effectStack.includes(effect3)) {
            $7c758c6c7663877f$var$cleanup(effect3);
            try {
                $7c758c6c7663877f$var$enableTracking();
                $7c758c6c7663877f$var$effectStack.push(effect3);
                $7c758c6c7663877f$var$activeEffect = effect3;
                return fn();
            } finally{
                $7c758c6c7663877f$var$effectStack.pop();
                $7c758c6c7663877f$var$resetTracking();
                $7c758c6c7663877f$var$activeEffect = $7c758c6c7663877f$var$effectStack[$7c758c6c7663877f$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $7c758c6c7663877f$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $7c758c6c7663877f$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $7c758c6c7663877f$var$shouldTrack = true;
var $7c758c6c7663877f$var$trackStack = [];
function $7c758c6c7663877f$var$pauseTracking() {
    $7c758c6c7663877f$var$trackStack.push($7c758c6c7663877f$var$shouldTrack);
    $7c758c6c7663877f$var$shouldTrack = false;
}
function $7c758c6c7663877f$var$enableTracking() {
    $7c758c6c7663877f$var$trackStack.push($7c758c6c7663877f$var$shouldTrack);
    $7c758c6c7663877f$var$shouldTrack = true;
}
function $7c758c6c7663877f$var$resetTracking() {
    const last = $7c758c6c7663877f$var$trackStack.pop();
    $7c758c6c7663877f$var$shouldTrack = last === void 0 ? true : last;
}
function $7c758c6c7663877f$var$track(target, type, key) {
    if (!$7c758c6c7663877f$var$shouldTrack || $7c758c6c7663877f$var$activeEffect === void 0) return;
    let depsMap = $7c758c6c7663877f$var$targetMap.get(target);
    if (!depsMap) $7c758c6c7663877f$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($7c758c6c7663877f$var$activeEffect)) {
        dep.add($7c758c6c7663877f$var$activeEffect);
        $7c758c6c7663877f$var$activeEffect.deps.push(dep);
        if ($7c758c6c7663877f$var$activeEffect.options.onTrack) $7c758c6c7663877f$var$activeEffect.options.onTrack({
            effect: $7c758c6c7663877f$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $7c758c6c7663877f$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $7c758c6c7663877f$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $7c758c6c7663877f$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $7c758c6c7663877f$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$7c758c6c7663877f$var$isArray(target)) {
                    add2(depsMap.get($7c758c6c7663877f$var$ITERATE_KEY));
                    if ($7c758c6c7663877f$var$isMap(target)) add2(depsMap.get($7c758c6c7663877f$var$MAP_KEY_ITERATE_KEY));
                } else if ($7c758c6c7663877f$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$7c758c6c7663877f$var$isArray(target)) {
                    add2(depsMap.get($7c758c6c7663877f$var$ITERATE_KEY));
                    if ($7c758c6c7663877f$var$isMap(target)) add2(depsMap.get($7c758c6c7663877f$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($7c758c6c7663877f$var$isMap(target)) add2(depsMap.get($7c758c6c7663877f$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $7c758c6c7663877f$var$isNonTrackableKeys = /* @__PURE__ */ $7c758c6c7663877f$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $7c758c6c7663877f$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($7c758c6c7663877f$var$isSymbol));
var $7c758c6c7663877f$var$get2 = /* @__PURE__ */ $7c758c6c7663877f$var$createGetter();
var $7c758c6c7663877f$var$readonlyGet = /* @__PURE__ */ $7c758c6c7663877f$var$createGetter(true);
var $7c758c6c7663877f$var$arrayInstrumentations = /* @__PURE__ */ $7c758c6c7663877f$var$createArrayInstrumentations();
function $7c758c6c7663877f$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $7c758c6c7663877f$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$7c758c6c7663877f$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($7c758c6c7663877f$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $7c758c6c7663877f$var$pauseTracking();
            const res = $7c758c6c7663877f$var$toRaw(this)[key].apply(this, args);
            $7c758c6c7663877f$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $7c758c6c7663877f$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $7c758c6c7663877f$var$shallowReadonlyMap : $7c758c6c7663877f$var$readonlyMap : shallow ? $7c758c6c7663877f$var$shallowReactiveMap : $7c758c6c7663877f$var$reactiveMap).get(target)) return target;
        const targetIsArray = $7c758c6c7663877f$var$isArray(target);
        if (!isReadonly && targetIsArray && $7c758c6c7663877f$var$hasOwn($7c758c6c7663877f$var$arrayInstrumentations, key)) return Reflect.get($7c758c6c7663877f$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($7c758c6c7663877f$var$isSymbol(key) ? $7c758c6c7663877f$var$builtInSymbols.has(key) : $7c758c6c7663877f$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $7c758c6c7663877f$var$track(target, "get", key);
        if (shallow) return res;
        if ($7c758c6c7663877f$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$7c758c6c7663877f$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($7c758c6c7663877f$var$isObject(res)) return isReadonly ? $7c758c6c7663877f$var$readonly(res) : $7c758c6c7663877f$var$reactive2(res);
        return res;
    };
}
var $7c758c6c7663877f$var$set2 = /* @__PURE__ */ $7c758c6c7663877f$var$createSetter();
function $7c758c6c7663877f$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $7c758c6c7663877f$var$toRaw(value);
            oldValue = $7c758c6c7663877f$var$toRaw(oldValue);
            if (!$7c758c6c7663877f$var$isArray(target) && $7c758c6c7663877f$var$isRef(oldValue) && !$7c758c6c7663877f$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $7c758c6c7663877f$var$isArray(target) && $7c758c6c7663877f$var$isIntegerKey(key) ? Number(key) < target.length : $7c758c6c7663877f$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $7c758c6c7663877f$var$toRaw(receiver)) {
            if (!hadKey) $7c758c6c7663877f$var$trigger(target, "add", key, value);
            else if ($7c758c6c7663877f$var$hasChanged(value, oldValue)) $7c758c6c7663877f$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $7c758c6c7663877f$var$deleteProperty(target, key) {
    const hadKey = $7c758c6c7663877f$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $7c758c6c7663877f$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $7c758c6c7663877f$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$7c758c6c7663877f$var$isSymbol(key) || !$7c758c6c7663877f$var$builtInSymbols.has(key)) $7c758c6c7663877f$var$track(target, "has", key);
    return result;
}
function $7c758c6c7663877f$var$ownKeys(target) {
    $7c758c6c7663877f$var$track(target, "iterate", $7c758c6c7663877f$var$isArray(target) ? "length" : $7c758c6c7663877f$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $7c758c6c7663877f$var$mutableHandlers = {
    get: $7c758c6c7663877f$var$get2,
    set: $7c758c6c7663877f$var$set2,
    deleteProperty: $7c758c6c7663877f$var$deleteProperty,
    has: $7c758c6c7663877f$var$has,
    ownKeys: $7c758c6c7663877f$var$ownKeys
};
var $7c758c6c7663877f$var$readonlyHandlers = {
    get: $7c758c6c7663877f$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $7c758c6c7663877f$var$toReactive = (value)=>$7c758c6c7663877f$var$isObject(value) ? $7c758c6c7663877f$var$reactive2(value) : value;
var $7c758c6c7663877f$var$toReadonly = (value)=>$7c758c6c7663877f$var$isObject(value) ? $7c758c6c7663877f$var$readonly(value) : value;
var $7c758c6c7663877f$var$toShallow = (value)=>value;
var $7c758c6c7663877f$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $7c758c6c7663877f$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $7c758c6c7663877f$var$toRaw(target);
    const rawKey = $7c758c6c7663877f$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "get", key);
    !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $7c758c6c7663877f$var$getProto(rawTarget);
    const wrap = isShallow ? $7c758c6c7663877f$var$toShallow : isReadonly ? $7c758c6c7663877f$var$toReadonly : $7c758c6c7663877f$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $7c758c6c7663877f$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $7c758c6c7663877f$var$toRaw(target);
    const rawKey = $7c758c6c7663877f$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "has", key);
    !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $7c758c6c7663877f$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $7c758c6c7663877f$var$track($7c758c6c7663877f$var$toRaw(target), "iterate", $7c758c6c7663877f$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $7c758c6c7663877f$var$add(value) {
    value = $7c758c6c7663877f$var$toRaw(value);
    const target = $7c758c6c7663877f$var$toRaw(this);
    const proto = $7c758c6c7663877f$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $7c758c6c7663877f$var$trigger(target, "add", value, value);
    }
    return this;
}
function $7c758c6c7663877f$var$set$1(key, value) {
    value = $7c758c6c7663877f$var$toRaw(value);
    const target = $7c758c6c7663877f$var$toRaw(this);
    const { has: has2, get: get3 } = $7c758c6c7663877f$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $7c758c6c7663877f$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $7c758c6c7663877f$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $7c758c6c7663877f$var$trigger(target, "add", key, value);
    else if ($7c758c6c7663877f$var$hasChanged(value, oldValue)) $7c758c6c7663877f$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $7c758c6c7663877f$var$deleteEntry(key) {
    const target = $7c758c6c7663877f$var$toRaw(this);
    const { has: has2, get: get3 } = $7c758c6c7663877f$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $7c758c6c7663877f$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $7c758c6c7663877f$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $7c758c6c7663877f$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $7c758c6c7663877f$var$clear() {
    const target = $7c758c6c7663877f$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $7c758c6c7663877f$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $7c758c6c7663877f$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $7c758c6c7663877f$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $7c758c6c7663877f$var$toRaw(target);
        const wrap = isShallow ? $7c758c6c7663877f$var$toShallow : isReadonly ? $7c758c6c7663877f$var$toReadonly : $7c758c6c7663877f$var$toReactive;
        !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "iterate", $7c758c6c7663877f$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $7c758c6c7663877f$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $7c758c6c7663877f$var$toRaw(target);
        const targetIsMap = $7c758c6c7663877f$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $7c758c6c7663877f$var$toShallow : isReadonly ? $7c758c6c7663877f$var$toReadonly : $7c758c6c7663877f$var$toReactive;
        !isReadonly && $7c758c6c7663877f$var$track(rawTarget, "iterate", isKeyOnly ? $7c758c6c7663877f$var$MAP_KEY_ITERATE_KEY : $7c758c6c7663877f$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $7c758c6c7663877f$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$7c758c6c7663877f$var$capitalize(type)} operation ${key}failed: target is readonly.`, $7c758c6c7663877f$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $7c758c6c7663877f$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $7c758c6c7663877f$var$get$1(this, key);
        },
        get size () {
            return $7c758c6c7663877f$var$size(this);
        },
        has: $7c758c6c7663877f$var$has$1,
        add: $7c758c6c7663877f$var$add,
        set: $7c758c6c7663877f$var$set$1,
        delete: $7c758c6c7663877f$var$deleteEntry,
        clear: $7c758c6c7663877f$var$clear,
        forEach: $7c758c6c7663877f$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $7c758c6c7663877f$var$get$1(this, key, false, true);
        },
        get size () {
            return $7c758c6c7663877f$var$size(this);
        },
        has: $7c758c6c7663877f$var$has$1,
        add: $7c758c6c7663877f$var$add,
        set: $7c758c6c7663877f$var$set$1,
        delete: $7c758c6c7663877f$var$deleteEntry,
        clear: $7c758c6c7663877f$var$clear,
        forEach: $7c758c6c7663877f$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $7c758c6c7663877f$var$get$1(this, key, true);
        },
        get size () {
            return $7c758c6c7663877f$var$size(this, true);
        },
        has (key) {
            return $7c758c6c7663877f$var$has$1.call(this, key, true);
        },
        add: $7c758c6c7663877f$var$createReadonlyMethod("add"),
        set: $7c758c6c7663877f$var$createReadonlyMethod("set"),
        delete: $7c758c6c7663877f$var$createReadonlyMethod("delete"),
        clear: $7c758c6c7663877f$var$createReadonlyMethod("clear"),
        forEach: $7c758c6c7663877f$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $7c758c6c7663877f$var$get$1(this, key, true, true);
        },
        get size () {
            return $7c758c6c7663877f$var$size(this, true);
        },
        has (key) {
            return $7c758c6c7663877f$var$has$1.call(this, key, true);
        },
        add: $7c758c6c7663877f$var$createReadonlyMethod("add"),
        set: $7c758c6c7663877f$var$createReadonlyMethod("set"),
        delete: $7c758c6c7663877f$var$createReadonlyMethod("delete"),
        clear: $7c758c6c7663877f$var$createReadonlyMethod("clear"),
        forEach: $7c758c6c7663877f$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $7c758c6c7663877f$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $7c758c6c7663877f$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $7c758c6c7663877f$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $7c758c6c7663877f$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$7c758c6c7663877f$var$mutableInstrumentations, $7c758c6c7663877f$var$readonlyInstrumentations, $7c758c6c7663877f$var$shallowInstrumentations, $7c758c6c7663877f$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $7c758c6c7663877f$var$createInstrumentations();
function $7c758c6c7663877f$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $7c758c6c7663877f$var$shallowReadonlyInstrumentations : $7c758c6c7663877f$var$shallowInstrumentations : isReadonly ? $7c758c6c7663877f$var$readonlyInstrumentations : $7c758c6c7663877f$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($7c758c6c7663877f$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $7c758c6c7663877f$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $7c758c6c7663877f$var$createInstrumentationGetter(false, false)
};
var $7c758c6c7663877f$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $7c758c6c7663877f$var$createInstrumentationGetter(true, false)
};
function $7c758c6c7663877f$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $7c758c6c7663877f$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $7c758c6c7663877f$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $7c758c6c7663877f$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $7c758c6c7663877f$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $7c758c6c7663877f$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $7c758c6c7663877f$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $7c758c6c7663877f$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $7c758c6c7663877f$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $7c758c6c7663877f$var$targetTypeMap($7c758c6c7663877f$var$toRawType(value));
}
function $7c758c6c7663877f$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $7c758c6c7663877f$var$createReactiveObject(target, false, $7c758c6c7663877f$var$mutableHandlers, $7c758c6c7663877f$var$mutableCollectionHandlers, $7c758c6c7663877f$var$reactiveMap);
}
function $7c758c6c7663877f$var$readonly(target) {
    return $7c758c6c7663877f$var$createReactiveObject(target, true, $7c758c6c7663877f$var$readonlyHandlers, $7c758c6c7663877f$var$readonlyCollectionHandlers, $7c758c6c7663877f$var$readonlyMap);
}
function $7c758c6c7663877f$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$7c758c6c7663877f$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $7c758c6c7663877f$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $7c758c6c7663877f$var$toRaw(observed) {
    return observed && $7c758c6c7663877f$var$toRaw(observed["__v_raw"]) || observed;
}
function $7c758c6c7663877f$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$7c758c6c7663877f$var$magic("nextTick", ()=>$7c758c6c7663877f$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$7c758c6c7663877f$var$magic("dispatch", (el)=>$7c758c6c7663877f$var$dispatch.bind($7c758c6c7663877f$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$7c758c6c7663877f$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $7c758c6c7663877f$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$7c758c6c7663877f$var$magic("store", $7c758c6c7663877f$var$getStores);
// packages/alpinejs/src/magics/$data.js
$7c758c6c7663877f$var$magic("data", (el)=>$7c758c6c7663877f$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$7c758c6c7663877f$var$magic("root", (el)=>$7c758c6c7663877f$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$7c758c6c7663877f$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $7c758c6c7663877f$var$mergeProxies($7c758c6c7663877f$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $7c758c6c7663877f$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $7c758c6c7663877f$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $7c758c6c7663877f$var$globalIdMemo = {};
function $7c758c6c7663877f$var$findAndIncrementId(name) {
    if (!$7c758c6c7663877f$var$globalIdMemo[name]) $7c758c6c7663877f$var$globalIdMemo[name] = 0;
    return ++$7c758c6c7663877f$var$globalIdMemo[name];
}
function $7c758c6c7663877f$var$closestIdRoot(el, name) {
    return $7c758c6c7663877f$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $7c758c6c7663877f$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $7c758c6c7663877f$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$7c758c6c7663877f$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $7c758c6c7663877f$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $7c758c6c7663877f$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $7c758c6c7663877f$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$7c758c6c7663877f$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $7c758c6c7663877f$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$7c758c6c7663877f$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$7c758c6c7663877f$var$warnMissingPluginMagic("Focus", "focus", "focus");
$7c758c6c7663877f$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $7c758c6c7663877f$var$warnMissingPluginMagic(name, magicName, slug) {
    $7c758c6c7663877f$var$magic(magicName, (el)=>$7c758c6c7663877f$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$7c758c6c7663877f$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $7c758c6c7663877f$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$7c758c6c7663877f$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $7c758c6c7663877f$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $7c758c6c7663877f$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $7c758c6c7663877f$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $7c758c6c7663877f$var$mutateDom(()=>{
        $7c758c6c7663877f$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $7c758c6c7663877f$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $7c758c6c7663877f$var$getTarget(expression);
        $7c758c6c7663877f$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$7c758c6c7663877f$var$mutateDom(()=>{
            clone2.remove();
            $7c758c6c7663877f$var$destroyTree(clone2);
        }));
});
var $7c758c6c7663877f$var$teleportContainerDuringClone = document.createElement("div");
function $7c758c6c7663877f$var$getTarget(expression) {
    let target = $7c758c6c7663877f$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $7c758c6c7663877f$var$teleportContainerDuringClone;
    })();
    if (!target) $7c758c6c7663877f$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $7c758c6c7663877f$var$handler = ()=>{};
$7c758c6c7663877f$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$7c758c6c7663877f$var$directive("ignore", $7c758c6c7663877f$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$7c758c6c7663877f$var$directive("effect", $7c758c6c7663877f$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($7c758c6c7663877f$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $7c758c6c7663877f$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $7c758c6c7663877f$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $7c758c6c7663877f$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $7c758c6c7663877f$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($7c758c6c7663877f$var$isKeyEvent(event) || $7c758c6c7663877f$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($7c758c6c7663877f$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $7c758c6c7663877f$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $7c758c6c7663877f$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $7c758c6c7663877f$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $7c758c6c7663877f$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $7c758c6c7663877f$var$throttle(handler4, wait);
    }
    return handler4;
}
function $7c758c6c7663877f$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $7c758c6c7663877f$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $7c758c6c7663877f$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $7c758c6c7663877f$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $7c758c6c7663877f$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $7c758c6c7663877f$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $7c758c6c7663877f$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $7c758c6c7663877f$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $7c758c6c7663877f$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $7c758c6c7663877f$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($7c758c6c7663877f$var$isClickEvent(e.type)) return false;
            if ($7c758c6c7663877f$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $7c758c6c7663877f$var$keyToModifiers(key) {
    if (!key) return [];
    key = $7c758c6c7663877f$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$7c758c6c7663877f$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $7c758c6c7663877f$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $7c758c6c7663877f$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $7c758c6c7663877f$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $7c758c6c7663877f$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $7c758c6c7663877f$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($7c758c6c7663877f$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $7c758c6c7663877f$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($7c758c6c7663877f$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($7c758c6c7663877f$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($7c758c6c7663877f$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($7c758c6c7663877f$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($7c758c6c7663877f$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $7c758c6c7663877f$var$on(el, event, modifiers, (e)=>{
            setValue($7c758c6c7663877f$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $7c758c6c7663877f$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($7c758c6c7663877f$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $7c758c6c7663877f$var$on(el.form, "reset", [], (e)=>{
            $7c758c6c7663877f$var$nextTick(()=>el._x_model && el._x_model.set($7c758c6c7663877f$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $7c758c6c7663877f$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $7c758c6c7663877f$var$mutateDom(()=>{
            if ($7c758c6c7663877f$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($7c758c6c7663877f$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $7c758c6c7663877f$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $7c758c6c7663877f$var$bind(el, "value", value);
        });
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $7c758c6c7663877f$var$getInputValue(el, modifiers, event, currentValue) {
    return $7c758c6c7663877f$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($7c758c6c7663877f$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $7c758c6c7663877f$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $7c758c6c7663877f$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$7c758c6c7663877f$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $7c758c6c7663877f$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $7c758c6c7663877f$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($7c758c6c7663877f$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $7c758c6c7663877f$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $7c758c6c7663877f$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $7c758c6c7663877f$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $7c758c6c7663877f$var$isNumeric2(number) ? number : rawValue;
}
function $7c758c6c7663877f$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $7c758c6c7663877f$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $7c758c6c7663877f$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$7c758c6c7663877f$var$directive("cloak", (el)=>queueMicrotask(()=>$7c758c6c7663877f$var$mutateDom(()=>el.removeAttribute($7c758c6c7663877f$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$7c758c6c7663877f$var$addInitSelector(()=>`[${$7c758c6c7663877f$var$prefix("init")}]`);
$7c758c6c7663877f$var$directive("init", $7c758c6c7663877f$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$7c758c6c7663877f$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $7c758c6c7663877f$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$7c758c6c7663877f$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $7c758c6c7663877f$var$mutateDom(()=>{
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $7c758c6c7663877f$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$7c758c6c7663877f$var$mapAttributes($7c758c6c7663877f$var$startingWith(":", $7c758c6c7663877f$var$into($7c758c6c7663877f$var$prefix("bind:"))));
var $7c758c6c7663877f$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $7c758c6c7663877f$var$injectBindingProviders(bindingProviders);
        let getBindings = $7c758c6c7663877f$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $7c758c6c7663877f$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $7c758c6c7663877f$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $7c758c6c7663877f$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $7c758c6c7663877f$var$mutateDom(()=>$7c758c6c7663877f$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$7c758c6c7663877f$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$7c758c6c7663877f$var$directive("bind", $7c758c6c7663877f$var$handler2);
function $7c758c6c7663877f$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$7c758c6c7663877f$var$addRootSelector(()=>`[${$7c758c6c7663877f$var$prefix("data")}]`);
$7c758c6c7663877f$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($7c758c6c7663877f$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $7c758c6c7663877f$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $7c758c6c7663877f$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $7c758c6c7663877f$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $7c758c6c7663877f$var$injectMagics(data2, el);
    let reactiveData = $7c758c6c7663877f$var$reactive(data2);
    $7c758c6c7663877f$var$initInterceptors(reactiveData);
    let undo = $7c758c6c7663877f$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $7c758c6c7663877f$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $7c758c6c7663877f$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$7c758c6c7663877f$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $7c758c6c7663877f$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$7c758c6c7663877f$var$isCloning) return false;
    if ($7c758c6c7663877f$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$7c758c6c7663877f$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $7c758c6c7663877f$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $7c758c6c7663877f$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $7c758c6c7663877f$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $7c758c6c7663877f$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$7c758c6c7663877f$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $7c758c6c7663877f$var$parseForExpression(expression);
    let evaluateItems = $7c758c6c7663877f$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $7c758c6c7663877f$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$7c758c6c7663877f$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        el._x_lookup.forEach((el2)=>$7c758c6c7663877f$var$mutateDom(()=>{
                $7c758c6c7663877f$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
    });
});
function $7c758c6c7663877f$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $7c758c6c7663877f$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($7c758c6c7663877f$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $7c758c6c7663877f$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $7c758c6c7663877f$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $7c758c6c7663877f$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $7c758c6c7663877f$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $7c758c6c7663877f$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $7c758c6c7663877f$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $7c758c6c7663877f$var$reactive(scope2);
                $7c758c6c7663877f$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $7c758c6c7663877f$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            $7c758c6c7663877f$var$skipDuringClone(()=>added.forEach((clone2)=>$7c758c6c7663877f$var$initTree(clone2)))();
        });
    });
}
function $7c758c6c7663877f$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $7c758c6c7663877f$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $7c758c6c7663877f$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $7c758c6c7663877f$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $7c758c6c7663877f$var$handler3() {}
$7c758c6c7663877f$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $7c758c6c7663877f$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$7c758c6c7663877f$var$directive("ref", $7c758c6c7663877f$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$7c758c6c7663877f$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $7c758c6c7663877f$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $7c758c6c7663877f$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $7c758c6c7663877f$var$addScopeToNode(clone2, {}, el);
        $7c758c6c7663877f$var$mutateDom(()=>{
            el.after(clone2);
            $7c758c6c7663877f$var$skipDuringClone(()=>$7c758c6c7663877f$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $7c758c6c7663877f$var$mutateDom(()=>{
                $7c758c6c7663877f$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$7c758c6c7663877f$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$7c758c6c7663877f$var$setIdRoot(el, name));
});
$7c758c6c7663877f$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$7c758c6c7663877f$var$mapAttributes($7c758c6c7663877f$var$startingWith("@", $7c758c6c7663877f$var$into($7c758c6c7663877f$var$prefix("on:"))));
$7c758c6c7663877f$var$directive("on", $7c758c6c7663877f$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $7c758c6c7663877f$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $7c758c6c7663877f$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$7c758c6c7663877f$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$7c758c6c7663877f$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$7c758c6c7663877f$var$warnMissingPluginDirective("Focus", "trap", "focus");
$7c758c6c7663877f$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $7c758c6c7663877f$var$warnMissingPluginDirective(name, directiveName, slug) {
    $7c758c6c7663877f$var$directive(directiveName, (el)=>$7c758c6c7663877f$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$7c758c6c7663877f$var$alpine_default.setEvaluator($7c758c6c7663877f$var$normalEvaluator);
$7c758c6c7663877f$var$alpine_default.setRawEvaluator($7c758c6c7663877f$var$normalRawEvaluator);
$7c758c6c7663877f$var$alpine_default.setReactivityEngine({
    reactive: $7c758c6c7663877f$var$reactive2,
    effect: $7c758c6c7663877f$var$effect2,
    release: $7c758c6c7663877f$var$stop,
    raw: $7c758c6c7663877f$var$toRaw
});
var $7c758c6c7663877f$export$b7ee041e4ad2afec = $7c758c6c7663877f$var$alpine_default;
// packages/alpinejs/builds/module.js
var $7c758c6c7663877f$export$2e2bcd8739ae039 = $7c758c6c7663877f$export$b7ee041e4ad2afec;

});

parcelRegister("e6Ki2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a247875ba456e1f$export$2e2bcd8739ae039; });

var $jHVjc = parcelRequire("jHVjc");

var $jWUp2 = parcelRequire("jWUp2");
function $6a247875ba456e1f$var$getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == ' ')c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return undefined;
}
function $6a247875ba456e1f$var$setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
var // We show the modal after 10 seconds if modal HTML exists.
// eslint-disable-next-line no-unused-vars
$6a247875ba456e1f$export$2e2bcd8739ae039 = ()=>({
        open: false,
        error: false,
        success: false,
        sending: false,
        can_save_cookie: false,
        // var debug = '{{DEBUG}}';
        debug: (0, $jWUp2.getJsonScriptData)('debug'),
        destinationSlug: (0, $jWUp2.getJsonScriptData)('destination_slug'),
        init () {
            const modalElement = document.getElementById('guide_modal');
            if (!modalElement) return;
            if ($6a247875ba456e1f$var$getCookie('guide_' + this.destinationSlug)) return;
            this.can_save_cookie = JSON.parse($6a247875ba456e1f$var$getCookie('gv_cookie_config') ?? "{}")['acceptPreferences'] ?? false;
            // Show the modal after 10 seconds.
            setTimeout(()=>{
                this.open = true;
                this.$nextTick(()=>{
                    document.getElementById('mautic_email')?.focus();
                    this.$dispatch('modal-update', 'open');
                });
            }, 10000);
        },
        close () {
            if (this.can_save_cookie) $6a247875ba456e1f$var$setCookie('guide_' + this.destinationSlug, 'closed', 0.5);
            // Close the modal
            this.open = false;
            this.success = false;
            this.$dispatch('modal-update', 'close');
        },
        async send () {
            let email = document.getElementById('mautic_email').value;
            if (!email) {
                this.error = "Por favor, escribe tu correo electr\xf3nico";
                return;
            }
            if (!(0, $jWUp2.isValidEmailAddress)(email)) {
                this.error = "Por favor, escribe un correo electr\xf3nico v\xe1lido";
                return;
            }
            this.sending = true;
            const result = await (0, $jHVjc.trigger_journey)(email, this.destinationSlug);
            this.sending = false;
            if (!result.success) {
                this.error = result.error;
                return;
            }
            if (!this.debug) // eslint-disable-next-line no-undef
            dataLayer.push({
                'event': 'guide'
            });
            this.open = false;
            this.error = false;
            this.success = true;
            if (this.can_save_cookie) // "Indefinite" in browsers is implemented with a very long-lived cookie.
            $6a247875ba456e1f$var$setCookie('guide_' + this.destinationSlug, 'sent', 36500);
        }
    });

});
parcelRegister("jHVjc", function(module, exports) {

$parcel$export(module.exports, "trigger_journey", function () { return $ad8cdc01bc798f5f$export$aebb6fffebfff8df; });
async function $ad8cdc01bc798f5f$export$aebb6fffebfff8df(email, journey_slug) {
    const CSRF_TOKEN = document.getElementsByName('csrfmiddlewaretoken')[0].value;
    // POST email to the backend
    const request = await fetch('/ajax/trigger-journey/', {
        method: 'POST',
        headers: {
            'X-CSRFToken': CSRF_TOKEN
        },
        body: JSON.stringify({
            email: email,
            journey_slug: journey_slug
        })
    });
    const data = await request.json();
    return data;
}

});


parcelRegister("1zle1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f08e399d99811864$export$2e2bcd8739ae039; });
// intlTelInput is NOT imported here — it's lazy-loaded inside initializeIntlTelInput()
// so the 429KB vendor file is excluded from the initial JS bundle.

var $lAfN7 = parcelRequire("lAfN7");
const $f08e399d99811864$var$AJAX_COUNTRY_CODE_URL = JSON.parse(document.getElementById("ajax_country_code_url").textContent);
const $f08e399d99811864$var$timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $f08e399d99811864$var$AJAX_CONVERSATION_URLS = JSON.parse(document.getElementById("ajax_conversation_urls")?.textContent || "{}");



var $f08e399d99811864$export$2e2bcd8739ae039 = ()=>({
        whatsAppModalOpen: false,
        whatsAppModalLoading: false,
        showMobileMenu: false,
        lastSelectedCountry: null,
        // Spread the chatbot module functionality
        ...(0, $lAfN7.default)($f08e399d99811864$var$AJAX_CONVERSATION_URLS, false),
        async openWhatsAppModal () {
            try {
                dataLayer.push({
                    'event': 'whatsapp_start',
                    'event_category': 'WhatsApp',
                    'event_label': 'WhatsApp Start'
                });
            } catch (error) {
                console.log('Error al enviar evento whatsapp_start a dataLayer:', error);
            }
            this.whatsAppModalOpen = true;
            this.whatsAppModalLoading = true;
            try {
                const response = await fetch(`${$f08e399d99811864$var$AJAX_COUNTRY_CODE_URL}?timezone=${$f08e399d99811864$var$timezone}`);
                const response_json = await response.json();
                const country_code1 = response_json.country_code;
                this.initializeIntlTelInput(country_code1);
            } catch (error) {
                console.error("Error fetching country code:", error);
            } finally{
                // Ensure reactivity is updated
                this.whatsAppModalLoading = false;
                this.$nextTick(()=>{
                    console.log("DOM has updated after loading state was changed.");
                });
            }
            // Listen for HTMX events to reinitialize the input after DOM swaps
            document.addEventListener("htmx:afterSwap", (event)=>{
                if (event.detail.target && event.detail.target.id === "whatsapp-form") // Reinitialize intl-tel-input on the updated input
                setTimeout(// HACK: to avoid the flags to be positioned on top of the input
                ()=>this.initializeIntlTelInput(this.lastSelectedCountry || country_code), 100);
            });
        },
        async initializeIntlTelInput (initialCountry) {
            const input = document.querySelector("#whatsapp-modal-telephone");
            if (!input) return;
            // Load on-demand: only fires when the user opens the WhatsApp modal,
            // keeping ~430KB of JS+CSS out of the initial bundle.
            // Parcel splits each dynamic import into its own chunk and injects CSS into <head>.
            // The vendor JS is UMD — fall back to the module itself if no ES default export.
            const [iti] = await Promise.all([
                (parcelRequire("fnheT")),
                (parcelRequire("dpp1b")),
                (parcelRequire("cleEE"))
            ]);
            const intlTelInput = iti.default || iti;
            const contact_iti_instance = intlTelInput(input, {
                initialCountry: initialCountry,
                formatAsYouType: false,
                formatOnDisplay: false,
                separateDialCode: true
            });
            const updateTelephoneInputs = ()=>{
                const countryData = contact_iti_instance.getSelectedCountryData();
                this.lastSelectedCountry = countryData.iso2; // Save the selected country
                document.querySelector("#whatsapp-modal-telephone-prefix").value = countryData.dialCode;
                document.querySelector("#whatsapp-modal-telephone-country-code").value = countryData.iso2;
            };
            // Update hidden inputs on initialization and country change
            updateTelephoneInputs();
            input.addEventListener("countrychange", updateTelephoneInputs);
        },
        openCookiesModal () {
            this.$dispatch('cookies-configure');
        }
    });

});
parcelRegister("lAfN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2198204abbfba07d$export$2e2bcd8739ae039; });
const $2198204abbfba07d$var$INITIAL_MESSAGE = `
Soy tu agente virtual y estoy aqu\xed para ayudarte con tus planes de viaje.
A veces utilizo IA para responder y la conversaci\xf3n puede grabarse para mejorar el servicio.
Para empezar, escribe tu pregunta.
`;
function $2198204abbfba07d$export$2e2bcd8739ae039(AJAX_CONVERSATION_URLS, milgrams_mode = false) {
    return {
        chatBotModal: {
            open: false,
            initialized: false,
            initializing: false,
            show_hint: localStorage.getItem('chatbot_hint_closed') === null ? true : false,
            slide_hint: false,
            conversation: [],
            waiting_for_response: false,
            current_message: '',
            error: null,
            waiting_for_response_timeout: null,
            waiting_for_response_message: null,
            waiting_for_response_interval: null,
            chat_start_sent: false,
            show_privacy_notice: true
        },
        async getOrCreateConversation () {
            this.chatBotModal.error = null;
            // Check session storage if some conversation has been started
            const conversation_started = sessionStorage.getItem('chatbot_conversation_started');
            let conversation = [];
            if (conversation_started) {
                // Fetch the conversation from the server
                let response;
                try {
                    response = await fetch(AJAX_CONVERSATION_URLS.get_conversation.replace(':conversation_id', conversation_started));
                } catch (error) {
                    console.error(error);
                    this.chatBotModal.error = "Ha ocurrido un error al obtener la conversaci\xf3n. Por favor, int\xe9ntalo de nuevo.";
                    return;
                }
                if (response.status !== 200) {
                    this.chatBotModal.error = "Ha ocurrido un error al obtener la conversaci\xf3n. Por favor, int\xe9ntalo de nuevo.";
                    return;
                }
                const response_json = await response.json();
                if (response_json.error) {
                    this.chatBotModal.error = response_json.error;
                    return;
                }
                conversation = response_json.messages;
                this.chatBotModal.show_privacy_notice = !conversation.some((message)=>message.role === 'user');
                // Add initial message to the start of the conversation
                conversation.unshift({
                    role: 'assistant',
                    content: $2198204abbfba07d$var$INITIAL_MESSAGE
                });
            } else {
                // Add initial message to the start of the conversation
                conversation.unshift({
                    role: 'assistant',
                    content: $2198204abbfba07d$var$INITIAL_MESSAGE
                });
                this.chatBotModal.conversation = conversation;
                this.chatBotModal.initializing = false; // fake, we want to hide that from the user
                const user_uuid = document.cookie.split('; ').find((row)=>row.startsWith('user_uuid='))?.split('=')[1];
                // Create a new conversation
                const response = await fetch(AJAX_CONVERSATION_URLS.create_conversation, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        landing_page: window.location.pathname,
                        user_uuid: user_uuid,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                    })
                });
                if (response.status !== 201) {
                    this.chatBotModal.error = "Ha ocurrido un error al crear la conversaci\xf3n. Por favor, int\xe9ntalo de nuevo.";
                    return;
                }
                const response_json = await response.json();
                if (response_json.error) {
                    this.chatBotModal.error = response_json.error;
                    return;
                }
                sessionStorage.setItem('chatbot_conversation_started', response_json.conversation_uuid);
            }
            conversation = conversation.map((message)=>({
                    role: message.role,
                    content: this.formatMessage(message.content)
                }));
            // Extend the conversation with the messages from the server
            this.chatBotModal.conversation = conversation;
        },
        async toggleChatBotModal () {
            // Open the ChatBot modal (embed from milgrams.cat)
            // If we open the modal we want to make sure the hint is not shown
            this.closeChatBotHint();
            this.chatBotModal.open = !this.chatBotModal.open;
            if (this.chatBotModal.open && !this.chatBotModal.chat_start_sent) {
                this.chatBotModal.chat_start_sent = true;
                try {
                    dataLayer.push({
                        'event': 'chat_start',
                        'event_category': 'Lead Generation',
                        'event_label': 'Chat Started'
                    });
                } catch (error) {
                    console.error("Error al enviar evento chat_start a dataLayer:", error);
                }
            }
            if (!this.chatBotModal.initialized && !this.chatBotModal.initializing) {
                this.chatBotModal.initializing = true;
                // Add the initial message to the conversation
                try {
                    await this.getOrCreateConversation();
                } catch (error) {
                    console.error(error);
                    this.chatBotModal.error = "Ha ocurrido un error al crear la conversaci\xf3n. Por favor, intenta de nuevo en unos minutos.";
                    this.chatBotModal.initializing = false;
                    return;
                }
                this.chatBotModal.initialized = true;
                this.chatBotModal.initializing = false;
            }
            if (this.chatBotModal.open) {
                setTimeout(()=>{
                    const input = document.getElementById('chatbot-user-input');
                    if (input) {
                        input.focus();
                        // Set the current message content if it exists
                        if (this.chatBotModal.current_message) input.textContent = this.chatBotModal.current_message;
                    }
                }, 100);
                this.scrollToBottom();
            }
        },
        scrollToBottom () {
            const modal = document.getElementById("chatbot-modal");
            const chatbotBody = modal.querySelector('.chatbot-body');
            // Allow alpine time to update the DOM
            setTimeout(()=>{
                chatbotBody.scrollTo({
                    top: chatbotBody.scrollHeight,
                    behavior: 'smooth'
                });
            }, 200);
        },
        formatMessage (message) {
            let formatted_message = message.trim();
            const openInNewTabAttrs = 'target="_blank" rel="noopener noreferrer"';
            const markdownLinkPlaceholders = [];
            // Format lists "- text" to <li>text</li> and wrap around <ul>
            formatted_message = formatted_message.replace(/(?:^|\n)((?:-\s+.+(?:\n|$))+)/g, (_match, listBlock)=>{
                const items = listBlock.trim().split('\n').map((line)=>line.replace(/^\s*-\s+/, '').trim()).filter(Boolean).map((item)=>`<li>${item}</li>`).join('');
                return `\n<ul>${items}</ul>`;
            });
            // Format Markdown links first ([text](url)) and keep placeholders
            // so plain-url replacement does not touch generated anchor URLs.
            formatted_message = formatted_message.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (_match, text, url)=>{
                const placeholder = `__MD_LINK_${markdownLinkPlaceholders.length}__`;
                markdownLinkPlaceholders.push(`<a href="${url}" ${openInNewTabAttrs}>${text}</a>`);
                return placeholder;
            });
            // Format plain urls to clickable links
            formatted_message = formatted_message.replace(/(https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*)/g, `<a href="$1" ${openInNewTabAttrs}>$1</a>`);
            // Restore markdown links
            formatted_message = formatted_message.replace(/__MD_LINK_(\d+)__/g, (_match, index)=>{
                return markdownLinkPlaceholders[Number(index)] ?? _match;
            });
            // Format Markdown bold text
            formatted_message = formatted_message.replace(/(\*\*)(.*?)(\*\*)/g, '<strong>$2</strong>');
            // Format Markdown italic text
            formatted_message = formatted_message.replace(/(\*)(.*?)(\*)/g, '<em>$2</em>');
            // Format newlines to <br> tags
            formatted_message = formatted_message.replace(/\n+/g, '<br>');
            return formatted_message;
        },
        async errorRecieved (message, error_message = "Ha ocurrido un error al enviar el mensaje. Por favor, int\xe9ntalo de nuevo.") {
            const input = document.getElementById('chatbot-user-input');
            // Recover message if something failed
            this.chatBotModal.current_message = message;
            this.chatBotModal.conversation.pop();
            // Restore the contenteditable div content
            if (input) input.innerHTML = message;
            this.chatBotModal.error = error_message;
        },
        async startWaitingForResponse () {
            const second = 1000;
            // Should already be true, but just in case
            this.chatBotModal.waiting_for_response = true;
            // Array of messages to cycle through
            const waitingMessages = [
                "Estoy consultando algunos datos, dame unos segundos...",
                "Sigo trabajando en tu consulta...",
                "Todav\xeda estoy procesando la informaci\xf3n...",
                "Un momento m\xe1s, casi termino..."
            ];
            let messageIndex = 0;
            // Set initial message after 5 seconds
            this.chatBotModal.waiting_for_response_timeout = setTimeout(()=>{
                this.chatBotModal.waiting_for_response_message = waitingMessages[messageIndex];
                queueMicrotask(()=>this.scrollToBottom());
                messageIndex = (messageIndex + 1) % waitingMessages.length;
                // Then cycle through messages every 5 seconds
                this.chatBotModal.waiting_for_response_interval = setInterval(()=>{
                    this.chatBotModal.waiting_for_response_message = waitingMessages[messageIndex];
                    queueMicrotask(()=>this.scrollToBottom());
                    messageIndex = (messageIndex + 1) % waitingMessages.length;
                }, 5 * second);
            }, 5 * second);
        },
        async stopWaitingForResponse () {
            this.chatBotModal.waiting_for_response = false;
            // Clear the timeout if it hasn't fired yet
            if (this.chatBotModal.waiting_for_response_timeout) {
                clearTimeout(this.chatBotModal.waiting_for_response_timeout);
                this.chatBotModal.waiting_for_response_timeout = null;
            }
            // Clear the interval if it's running
            if (this.chatBotModal.waiting_for_response_interval) {
                clearInterval(this.chatBotModal.waiting_for_response_interval);
                this.chatBotModal.waiting_for_response_interval = null;
            }
            // Clear the message
            this.chatBotModal.waiting_for_response_message = null;
        },
        async sendMessageToChatBot () {
            if (!this.chatBotModal.current_message) return;
            if (this.chatBotModal.current_message.length === 0) return;
            if (this.chatBotModal.open === false) return;
            if (this.chatBotModal.waiting_for_response) return;
            this.chatBotModal.waiting_for_response = true;
            const message = this.chatBotModal.current_message;
            this.chatBotModal.current_message = '';
            // Clear the contenteditable div
            const input = document.getElementById('chatbot-user-input');
            if (input) input.innerHTML = '';
            // Add the message to the conversation
            this.chatBotModal.conversation.push({
                role: 'user',
                content: message
            });
            this.chatBotModal.show_privacy_notice = false;
            this.scrollToBottom();
            this.chatBotModal.error = null;
            // If we have not initialized the chatbot, wait for it
            if (this.chatBotModal.initialized === false) while(this.chatBotModal.initialized === false){
                if (this.chatBotModal.initializing === false) {
                    this.errorRecieved(message);
                    this.chatBotModal.waiting_for_response = false;
                    return;
                }
                await new Promise((resolve)=>setTimeout(resolve, 100));
            }
            let response;
            try {
                this.startWaitingForResponse();
                response = await fetch(AJAX_CONVERSATION_URLS.send_message.replace(':conversation_id', sessionStorage.getItem('chatbot_conversation_started')), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        message: message
                    })
                });
            } catch (error) {
                console.error("Error sending message to chatbot:", error);
                this.errorRecieved(message);
                return;
            } finally{
                this.stopWaitingForResponse();
            }
            let response_json;
            try {
                response_json = await response.json();
            } catch (error) {
                response_json = null;
            }
            if (response.status !== 200) {
                if (response_json && response_json.code) switch(response_json.code){
                    case "conversation_limit":
                        this.errorRecieved(message, `Esta conversaci\xf3n ha llegado a su l\xedmite.
								Pudes iniciar otra conversaci\xf3n en una pesta\xf1a diferente.`);
                        return;
                    case "time_limit":
                        this.errorRecieved(message, `Has enviado muchos mensajes r\xe0pidamente.
								Por favor, espera unos segundos y prueba de nuevo.`);
                        return;
                    default:
                        this.errorRecieved(message);
                        return;
                }
                this.errorRecieved(message);
                return;
            }
            this.chatBotModal.conversation.push({
                role: 'assistant',
                content: this.formatMessage(response_json.message)
            });
            this.scrollToBottom();
        },
        async initChatBotHint () {
            if (milgrams_mode) return; // Prevent showing two hints when milgrams is enabled
            await new Promise((resolve)=>setTimeout(resolve, 5000));
            this.chatBotModal.slide_hint = true;
        },
        closeChatBotHint () {
            localStorage.setItem('chatbot_hint_closed', true);
            this.chatBotModal.show_hint = false;
        },
        updateChatbotMessage (target) {
            // If only element is a <br> remove it
            if (target.children.length === 1 && target.children[0].tagName === 'BR') {
                target.innerHTML = '';
                return;
            }
            let textContent = target.textContent;
            // Limit to 255 characters
            if (textContent.length > 255) {
                textContent = textContent.substring(0, 255);
                // Update the contenteditable div to reflect the truncated text
                this.$nextTick(()=>{
                    const input = document.getElementById('chatbot-user-input');
                    if (input) {
                        input.innerHTML = textContent;
                        // Place cursor at the end
                        const range = document.createRange();
                        const selection = window.getSelection();
                        range.selectNodeContents(input);
                        range.collapse(false);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                });
            }
            this.chatBotModal.current_message = textContent;
        },
        handlePaste (event) {
            event.preventDefault();
            const text = event.clipboardData.getData('text/plain');
            document.execCommand('insertText', false, text);
        }
    };
}

});

parcelRegister("fnheT", function(module, exports) {

module.exports = (parcelRequire("es6wD"))($parcel$resolve("d1pGu")).then(()=>parcelRequire('6nJhF'));

});
parcelRegister("es6wD", function(module, exports) {
"use strict";

var $42fa6 = parcelRequire("42fa6");
module.exports = $42fa6(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("42fa6", function(module, exports) {
"use strict";
var $2f031c269d940b22$var$cachedBundles = {};
var $2f031c269d940b22$var$cachedPreloads = {};
var $2f031c269d940b22$var$cachedPrefetches = {};
function $2f031c269d940b22$var$getCache(type) {
    switch(type){
        case 'preload':
            return $2f031c269d940b22$var$cachedPreloads;
        case 'prefetch':
            return $2f031c269d940b22$var$cachedPrefetches;
        default:
            return $2f031c269d940b22$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $2f031c269d940b22$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dpp1b", function(module, exports) {

module.exports = (parcelRequire("2kHYW"))($parcel$resolve("74XyR"));

});
parcelRegister("2kHYW", function(module, exports) {
"use strict";

var $42fa6 = parcelRequire("42fa6");
module.exports = $42fa6(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("cleEE", function(module, exports) {

module.exports = (parcelRequire("2kHYW"))($parcel$resolve("f3S5A"));

});


parcelRegister("1t392", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fabfffeb0525b0$export$2e2bcd8739ae039; });

var $jWUp2 = parcelRequire("jWUp2");
// source: https://business.safety.google/adscookies/
var $35fabfffeb0525b0$var$CookiesList = {
    necessary: [
        {
            provider: 'GrandVoyage',
            cookies: [
                {
                    name: 'gv_cookie_config',
                    description: "Almacena esta configuraci\xf3n de cookies del usuario"
                },
                {
                    name: 'csrftoken',
                    description: 'Cookie de seguridad. Sin esta cookie el servidor no aceptara ninguna de tus peticiones POST.'
                },
                {
                    name: 'sessionid',
                    description: "Cookie de sesi\xf3n. Almacena la sesi\xf3n del usuario."
                }
            ]
        }
    ],
    anonanalytics: [
        {
            provider: 'GrandVoyage',
            cookies: [
                {
                    name: 'user_uuid',
                    description: 'Usado para identificar los caminos de los usuarios dentro del sitio web.'
                }
            ]
        }
    ],
    preferences: [
        {
            provider: 'GrandVoyage',
            cookies: [
                {
                    name: 'guide_india',
                    description: "Usada para recordar si ya le hemos mostrado la opci\xf3n de descargar la gu\xeda de la India.",
                    storage: 'Session'
                },
                {
                    name: 'guide_tailandia',
                    description: "Usada para recordar si ya le hemos mostrado la opci\xf3n de descargar la gu\xeda de Tailandia.",
                    storage: 'Session'
                },
                {
                    name: 'guide_vietnam',
                    description: "Usada para recordar si ya le hemos mostrado la opci\xf3n de descargar la gu\xeda de Vietnam.",
                    storage: 'Session'
                }
            ]
        }
    ],
    marketing: [
        {
            provider: 'Google',
            cookies: [
                {
                    name: '_ga',
                    description: 'Usada para distinguir usuarios',
                    storage: "2 a\xf1os"
                },
                {
                    name: '_ga_#',
                    description: "Usada para guardar el estado de la sesi\xf3n",
                    storage: "2 a\xf1os"
                },
                {
                    name: '_git',
                    description: 'Utilizado por Google Analytics para controlar la tasa de peticiones',
                    storage: "1 d\xeda"
                },
                {
                    name: '_gid',
                    description: "Registra una identificaci\xf3n \xfanica que se utiliza para generar datos estad\xedsticos acerca de c\xf3mo utiliza el visitante el sitio web.",
                    storage: "1 d\xeda"
                },
                {
                    name: 'IDE',
                    description: '-',
                    storage: "2 a\xf1os"
                },
                {
                    name: '_gcl_au',
                    description: '-',
                    storage: "90 d\xedas"
                },
                {
                    name: '_gcl_aw',
                    description: '-',
                    storage: "90 d\xedas"
                },
                {
                    name: 'SNID',
                    description: '-',
                    storage: '6 meses'
                },
                {
                    name: 'NID',
                    description: '-',
                    storage: '6 meses'
                },
                {
                    name: 'OGPC',
                    description: '-',
                    storage: '1 mes'
                },
                {
                    name: 'DV',
                    description: '-',
                    storage: "1 d\xeda"
                },
                {
                    name: 'SOCS',
                    description: '-',
                    storage: '13 meses'
                }
            ]
        }
    ],
    mysc: [
        {
            provider: 'Cetelem',
            cookies: [
                {
                    name: 'ECREDITNOWID',
                    description: '-'
                },
                {
                    name: 'JSESSIONID',
                    description: '-'
                },
                {
                    name: 'LFR_SESSION_STATE_20120',
                    description: '-'
                },
                {
                    name: 'ROUTEID',
                    description: '-'
                },
                {
                    name: '_hjHasCachedUserAttributes',
                    description: '-'
                },
                {
                    name: '_hjSessionUser_1198973',
                    description: '-'
                },
                {
                    name: 'dtCookie',
                    description: '-'
                }
            ]
        },
        {
            provider: 'Bing',
            cookies: [
                {
                    name: '_uetsid',
                    description: '-'
                },
                {
                    name: '_uetvid',
                    description: '-'
                },
                {
                    name: 'MUID',
                    description: '-'
                }
            ]
        },
        {
            provider: 'Spotify',
            cookies: [
                {
                    name: 'sp_landing',
                    description: '-'
                },
                {
                    name: 'sp_t',
                    description: '-'
                }
            ]
        },
        {
            provider: 'Youtube',
            cookies: [
                {
                    name: 'GPS',
                    description: '-'
                },
                {
                    name: 'VISITOR_INFO1_LIVE',
                    description: '-'
                },
                {
                    name: 'VISITOR_PRIVACY_METADATA',
                    description: '-'
                }
            ]
        }
    ]
};
class $35fabfffeb0525b0$var$CookieCategoryTab {
    constructor(category){
        this.category = category;
        const container = document.querySelector(`#cookie-category-${category} .cookie-category-list`);
        if (container) container.innerHTML = `
				${$35fabfffeb0525b0$var$CookiesList[category].map((provider)=>`
					<div class="cookie-provider">
						<b class="cookie-provider-title">${provider.provider}</b>
						<div class="table-responsive">
							<table class="table" style="font-size: 1rem">
								<tr>
									<th>Cookie</th>
									<th>Caducidad</th>
									<th>Descripci\xf3n</th>
								</tr>
								${provider.cookies.map((cookie)=>`
									<tr>
										<td>${cookie.name}</td>
										<td>${cookie.storage ? cookie.storage : '-'}</td>
										<td>
											${cookie.description}
										</td>
									</tr>
								`).join('')}
							</table>
						</div>
					</div>
				`).join('')}
			`;
        const titles = document.querySelectorAll(`#cookie-category-${category} .cookie-provider-title`);
        titles.forEach(function(title) {
            title.addEventListener('click', function() {
                title.parentElement.classList.toggle('active');
            });
        });
    }
}
var $35fabfffeb0525b0$var$GVCookieModal = {
    config: {
        acceptPreferences: true,
        acceptAnalytics: true,
        acceptMarketing: true
    },
    open: false,
    config_ready: false,
    setCookie: function(session1 = false) {
        const value = JSON.stringify(this.config);
        (0, $jWUp2.setCookieOrSessionStorage)('gv_cookie_config', value, 3650, session1); // 10 years
        this.syncConfig();
        try {
            // eslint-disable-next-line no-undef
            dataLayer.push({
                'event': 'gv_consent_update'
            });
        } catch  {
            console.log('Error updating google analytics');
        }
    },
    ajaxAction: function(action) {
        const csrf = document.getElementsByName('csrfmiddlewaretoken')[0]?.value || '';
        const body = new URLSearchParams({
            csrfmiddlewaretoken: csrf,
            action: String(action)
        });
        fetch('/ajax/cookie_config_update/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body
        }).catch(function() {});
    },
    acceptAll: function() {
        this.config = {
            acceptPreferences: true,
            acceptAnalytics: true,
            acceptMarketing: true
        };
        this.setCookie();
        this.close();
        this.ajaxAction(2);
    },
    acceptSelection: function() {
        this.config = {
            acceptPreferences: document.getElementById('cookie-input-preferences').checked,
            acceptAnalytics: document.getElementById('cookie-input-analytics').checked,
            acceptMarketing: document.getElementById('cookie-input-marketing').checked
        };
        this.setCookie();
        this.close();
        this.ajaxAction(1);
    },
    decline: function() {
        this.config = {
            acceptPreferences: false,
            acceptAnalytics: false,
            acceptMarketing: false
        };
        this.setCookie(session = true);
        this.close();
        this.ajaxAction(0);
    },
    close: function() {
        const cookie = (0, $jWUp2.getCookieOrSessionStorage)('gv_cookie_config');
        if (cookie) {
            const modal = document.getElementById('cookies-modal');
            if (modal) modal.style.display = 'none';
            this.open = false;
            return;
        }
        /* IF no configuration was accepted, we re-show the banner*/ const modal = document.getElementById('cookies-modal');
        if (modal) modal.classList.remove('modal-version');
        const acceptBtn = document.getElementById('cookies-accept-selection-btn');
        if (acceptBtn) {
            const newBtn = document.createElement('button');
            newBtn.className = 'button is-outlined';
            newBtn.id = 'cookies-configure-btn';
            newBtn.textContent = 'Configurar';
            acceptBtn.replaceWith(newBtn);
            newBtn.addEventListener('click', function() {
                $35fabfffeb0525b0$var$GVCookieModal.openConfiguration();
            });
        }
        const info = document.getElementById('cookies-info');
        const configure = document.getElementById('cookies-configure');
        if (info) info.style.display = '';
        if (configure) configure.style.display = 'none';
    },
    setup: function() {
        const cookie = (0, $jWUp2.getCookieOrSessionStorage)('gv_cookie_config');
        if (cookie) {
            this.config = JSON.parse(cookie);
            this.syncConfig();
            return;
        }
        const modal = document.getElementById('cookies-modal');
        if (modal) modal.style.display = '';
        this.open = true;
    },
    setup_config: function() {
        const configure = document.getElementById('cookies-configure');
        if (configure) configure.innerHTML = `
			<span class="modal-title">Uso de cookies</span>
			<div class="cookie-category" id="cookie-category-necessary">
				<div class="cookie-category-title">
					<b>Necesarias</b>
					<label class="switch">
					  <input type="checkbox" checked disabled>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies necesarias ayudan a hacer una p\xe1gina web utilizable activando funciones b\xe1sicas como la navegaci\xf3n en la p\xe1gina y el acceso a \xe1reas seguras de la p\xe1gina web. la p\xe1gina web no puede funcionar adecuadamente sin estas cookies.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-anonanalytics">
				<div class="cookie-category-title">
					<b>Cookies anal\xedticas an\xf3nimas</b>
					<label class="switch">
					  <input type="checkbox" checked disabled>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Estas cookies nos permiten contar las visitas y fuentes de circulaci\xf3n para poder medir y mejorar el desempe\xf1o de nuestro sitio. Nos ayudan a saber qu\xe9 p\xe1ginas son las m\xe1s o menos populares, y ver cu\xe1ntas personas visitan el sitio.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-preferences">
				<div class="cookie-category-title">
					<b>Preferencias</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-preferences" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies de preferencias permiten a la p\xe1gina web recordar informaci\xf3n que cambia la forma en que la p\xe1gina se comporta o el aspecto que tiene, como su idioma preferido o la regi\xf3n en la que usted se encuentra.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-analytics">
				<div class="cookie-category-title">
					<b>Estad\xedstica</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-analytics" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies estad\xedsticas ayudan a los propietarios de p\xe1ginas web a comprender c\xf3mo interact\xfaan los visitantes con las p\xe1ginas web reuniendo y proporcionando informaci\xf3n de forma an\xf3nima.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-marketing">
				<div class="cookie-category-title">
					<b>Marketing</b>
					<label class="switch">
					  <input type="checkbox" id="cookie-input-marketing" checked>
					  <span class="slider round"></span>
					</label>
				</div>
				<p>
					Las cookies de marketing se utilizan para rastrear a los visitantes en las p\xe1ginas web. La intenci\xf3n es mostrar anuncios relevantes y atractivos para el usuario individual, y por lo tanto, m\xe1s valiosos para los editores y terceros anunciantes.
				</p>

				<div class="cookie-category-list"></div>
			</div>

			<div class="cookie-category" id="cookie-category-mysc">
				<div class="cookie-category-title">
					<b>Sin categorizar</b>
				</div>
				<p>
					Las cookies no clasificadas son cookies para las que todav\xeda estamos en proceso de clasificar.
				</p>

				<div class="cookie-category-list"></div>
			</div>
			<br>
		`;
        this.config_ready = true;
    },
    openConfiguration: function() {
        this.open = true;
        const modal = document.getElementById('cookies-modal');
        if (modal) modal.classList.add('modal-version');
        const configureBtn = document.getElementById('cookies-configure-btn');
        if (configureBtn) {
            const newBtn = document.createElement('button');
            newBtn.className = 'button is-outlined';
            newBtn.id = 'cookies-accept-selection-btn';
            newBtn.textContent = "Aceptar selecci\xf3n";
            configureBtn.replaceWith(newBtn);
        }
        if (!this.config_ready) this.setup_config();
        const info = document.getElementById('cookies-info');
        const configure = document.getElementById('cookies-configure');
        if (info) info.style.display = 'none';
        if (configure) configure.style.display = '';
        if (modal) modal.style.display = '';
        const acceptBtn = document.getElementById('cookies-accept-selection-btn');
        if (acceptBtn) acceptBtn.addEventListener('click', function() {
            $35fabfffeb0525b0$var$GVCookieModal.acceptSelection();
        });
        for(const category in $35fabfffeb0525b0$var$CookiesList)new $35fabfffeb0525b0$var$CookieCategoryTab(category);
    },
    syncConfig: function() {
        const pref = document.getElementById('cookie-input-preferences');
        const anal = document.getElementById('cookie-input-analytics');
        const mark = document.getElementById('cookie-input-marketing');
        if (pref) pref.checked = this.config.acceptPreferences;
        if (anal) anal.checked = this.config.acceptAnalytics;
        if (mark) mark.checked = this.config.acceptMarketing;
    }
};
var // TODO: At some point this whole object should be reworked to be a proper Alpine module
// but for now it's a quick fix to get the cookies modal working with Alpine
$35fabfffeb0525b0$export$2e2bcd8739ae039 = ()=>({
        cookiesObject: $35fabfffeb0525b0$var$GVCookieModal,
        open: false,
        updateModalState () {
            if (this.cookiesObject.open !== this.open) {
                this.open = this.cookiesObject.open;
                this.$dispatch('modal-update', this.open ? 'open' : 'close');
            }
        },
        openConfiguration () {
            this.cookiesObject.openConfiguration();
            this.updateModalState();
        },
        init () {
            const self = this;
            const cfgBtn = document.getElementById('cookies-configure-btn');
            if (cfgBtn) cfgBtn.addEventListener('click', function() {
                self.cookiesObject.openConfiguration();
            });
            const acceptBtn = document.getElementById('cookies-accept-btn');
            if (acceptBtn) acceptBtn.addEventListener('click', function() {
                self.cookiesObject.acceptAll();
                self.updateModalState();
            });
            const denyBtn = document.getElementById('cookies-deny-btn');
            if (denyBtn) denyBtn.addEventListener('click', function() {
                self.cookiesObject.decline();
                self.updateModalState();
            });
            /* Close modal on tap/click out */ const content = document.querySelector('.cookies-modal-content');
            if (content) content.addEventListener('click', function(e) {
                e.stopPropagation();
            });
            const modal = document.getElementById('cookies-modal');
            if (modal) modal.addEventListener('click', function() {
                self.cookiesObject.close();
                self.updateModalState();
            });
            this.cookiesObject.setup();
            this.updateModalState();
        }
    });

});


parcelRegister("8fhAc", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", function () { return $1d64ea746e1dd489$export$2cdf1b96a9f86d16; });
/**
 * Copies text to clipboard, with a fallback for browsers without Clipboard API.
 *
 * @param {string} text
 * @returns {Promise<void>}
 */ async function $1d64ea746e1dd489$export$2cdf1b96a9f86d16(text) {
    const value = text ?? "";
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
    }
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (!copied) throw new Error("Could not copy the text");
}

});

parcelRegister("84Ks3", function(module, exports) {

$parcel$export(module.exports, "DestinationNavbarSticky", function () { return $322d04729fdd653b$export$fa5b9562209c4e26; });
// Sticky behaviour for the country sub-navbar (.destination-navbar).
//
// `_destination_navbar.scss` anchors the sub-navbar below the main navbar
// using two CSS variables that depend on actual rendered heights:
//   --main-navbar-height            height of the main .navbar-wrapper
//   --main-destination-height       height of the main destination row (back
//                                   arrow + country name) inside the sub-navbar
//
// Both values can change with the viewport (responsive layout) and with
// elements appearing/disappearing above the navbar (e.g. promo-banner), so
// they are measured at runtime and refreshed via a ResizeObserver.
class $322d04729fdd653b$export$fa5b9562209c4e26 {
    constructor(){
        this.root = document.querySelector(".destination-navbar");
        if (!this.root) return; // No-op on pages without the white sub-navbar.
        this.mainNavbar = document.querySelector(".navbar-wrapper");
        this.tabs = this.root.querySelector(".destination-pages");
        this.update = this.update.bind(this); // necessary because `update` is called as a callback
        this.update();
        if (typeof ResizeObserver !== "undefined") {
            const observer = new ResizeObserver(this.update);
            if (this.mainNavbar) observer.observe(this.mainNavbar);
            observer.observe(this.root);
        }
        this._resizeTimer = null;
        window.addEventListener("resize", ()=>{
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(this.update, 250);
        });
    }
    update() {
        if (this.mainNavbar) {
            const h = this.mainNavbar.getBoundingClientRect().height;
            if (h > 0) document.documentElement.style.setProperty("--main-navbar-height", h + "px");
        }
        if (this.tabs && this.root) {
            const navTop = this.root.getBoundingClientRect().top;
            const tabsTop = this.tabs.getBoundingClientRect().top;
            const h = tabsTop - navTop;
            if (h > 0) document.documentElement.style.setProperty("--main-destination-height", h + "px");
        }
    }
}

});


parcelRegister("ag7E5", function(module, exports) {

module.exports = (parcelRequire("es6wD"))($parcel$resolve("9gQnY")).then(()=>parcelRequire('g2Lg5'));

});

parcelRequire("gi2dh");
// Testimonials Swiper is below the fold. Use IntersectionObserver to defer
// loading its module until the section is near the viewport. Parcel will
// code-split this into a separate chunk, keeping the initial home.js bundle
// smaller and reducing main-thread parse work on page load.
const $66d7ebd18f7935f8$var$testimonialsEl = document.querySelector('.testimonials-swiper');

if ($66d7ebd18f7935f8$var$testimonialsEl) {
    const observer = new IntersectionObserver((entries, obs)=>{
        if (entries[0].isIntersecting) {
            obs.disconnect();
            (parcelRequire("ag7E5"));
        }
    }, {
        rootMargin: '200px'
    }); // 200px margin triggers fetch slightly before visible
    observer.observe($66d7ebd18f7935f8$var$testimonialsEl);
}


parcelRequire("j0yfM");
})();
//# sourceMappingURL=about-us.js.map
